const de = {
  'common.loading': 'Wird geladen…',
  'common.save': 'Speichern',
  'common.saving': 'Wird gespeichert…',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.search': 'Suchen',
  'common.sortBy': 'Sortieren nach',
  'common.never': 'Nie',
  'common.justNow': 'Gerade eben',
  'common.accessDenied': 'Zugriff verweigert',
  'common.backToLogin': 'Zurück zur Anmeldung',
  'common.markAsRead': 'Als gelesen markieren',
  'common.user': 'Benutzer',
  'shell.supportDesk': 'Support Desk',
  'shell.searchPlaceholder': 'Tickets, Kontakte, Artikel suchen…',
  'shell.newTicket': 'Neues Ticket',
  'shell.notifications': 'Benachrichtigungen',
  'shell.notificationPreferences': 'Benachrichtigungseinstellungen',
  'shell.settings': 'Einstellungen',
  'shell.signOut': 'Abmelden',
  'shell.expandNavigation': 'Navigation erweitern',
  'shell.collapseNavigation': 'Navigation reduzieren',
  'shell.adminNavigation': 'Administrationsnavigation',
  'shell.caughtUp': 'Alles erledigt',
  'shell.viewAllNotifications': 'Alle Benachrichtigungen anzeigen',
  'nav.dashboard': 'Dashboard',
  'nav.tickets': 'Tickets',
  'nav.contacts': 'Kontakte',
  'nav.companies': 'Unternehmen',
  'nav.reports': 'Berichte',
  'nav.settings': 'Einstellungen',
  'nav.agents': 'Agenten',
  'nav.groups': 'Gruppen',
  'nav.roles': 'Rollen',
  'nav.tags': 'Tags',
  'nav.ticketFields': 'Ticketfelder',
  'nav.ticketForms': 'Ticketformulare',
  'nav.businessHours': 'Geschäftszeiten',
  'nav.slaPolicies': 'SLA-Richtlinien',
  'nav.automations': 'Automatisierungen',
  'nav.email': 'E-Mail',
  'nav.notificationTemplates': 'Benachrichtigungsvorlagen',
  'nav.apiKeys': 'API-Schlüssel',
  'nav.cannedResponses': 'Vorbereitete Antworten',
  'nav.knowledgeBase': 'Wissensdatenbank',
  'auth.signInTitle': 'SDPL Support Desk',
  'auth.signInSubtitle': 'Melden Sie sich bei Ihrem Konto an',
  'auth.emailAddress': 'E-Mail-Adresse',
  'auth.password': 'Passwort',
  'auth.signingIn': 'Anmeldung…',
  'auth.signIn': 'Anmelden',
  'auth.forgotPassword': 'Passwort vergessen?',
  'auth.twoFactor': 'Zwei-Faktor-Authentifizierung',
  'auth.verificationCode': 'Bestätigungscode',
  'auth.verify': 'Bestätigen',
  'auth.backToLogin': 'Zurück zur Anmeldung',
  'agents.title': 'Agenten',
  'agents.new': 'Neuer Agent',
  'agents.supportAgents': 'Support-Agenten',
  'agents.collaborators': 'Mitarbeiter',
  'agents.deactivated': 'Deaktiviert',
  'agents.searchPlaceholder': 'Nach Name oder E-Mail suchen',
  'agents.noSearchResults': 'Keine Agenten entsprechen dieser Suche',
  'agents.noAgentsView': 'Keine Agenten in dieser Ansicht',
  'agents.edit': 'Bearbeiten',
  'agents.deactivate': 'Deaktivieren',
  'agents.reactivate': 'Reaktivieren',
  'agents.saved': 'Agent gespeichert.',
  'agents.firstName': 'Vorname',
  'agents.lastName': 'Nachname',
  'agents.email': 'E-Mail',
  'agents.phone': 'Telefon',
  'agents.timezone': 'Zeitzone',
  'agents.selectTimezone': 'Zeitzone auswählen',
  'agents.language': 'Sprache',
  'agents.selectLanguage': 'Sprache auswählen',
  'agents.emailSignature': 'E-Mail-Signatur',
  'agents.roleRequired': 'Rolle',
  'agents.selectRole': 'Rolle auswählen',
  'agents.status': 'Status',
  'agents.groupsTitle': 'Gruppen',
  'agents.manageGroups': 'Gruppen verwalten',
  'agents.notInGroup': 'Noch keiner Gruppe zugeordnet',
  'dashboard.title': 'Dashboard',
  'dashboard.description': 'Aktuelle Supportauslastung und Servicezustand.',
  'dashboard.allGroups': 'Alle zugänglichen Gruppen',
  'dashboard.unresolved': 'Ungelöst',
  'dashboard.overdue': 'Überfällig',
  'dashboard.dueToday': 'Heute fällig',
  'dashboard.open': 'Offen',
  'dashboard.onHold': 'Zurückgestellt',
  'dashboard.unassigned': 'Nicht zugewiesen',
  'dashboard.trends': 'Heutige Trends',
  'dashboard.today': 'Heute',
  'dashboard.yesterday': 'Gestern',
  'notifications.title': 'Benachrichtigungen',
  'notifications.description': 'Ihre vollständige Benachrichtigungshistorie.',
  'notifications.markAllRead': 'Alle als gelesen markieren',
  'notifications.filter': 'Filter',
  'notifications.allTypes': 'Alle Typen',
  'notifications.none': 'Noch keine Benachrichtigungen',
  'notifications.assigned': 'Zugewiesen',
  'notifications.reply': 'Antwort',
  'notifications.note': 'Notiz',
  'notifications.slaWarning': 'SLA-Warnung',
  'notifications.slaBreach': 'SLA-Verletzung',
  'notifications.slaEscalation': 'SLA-Eskalation',
  'notifications.mention': 'Erwähnung',
  'preferences.title': 'Benachrichtigungseinstellungen',
  'preferences.description': 'In-App-Benachrichtigungen bleiben aktiv. Wählen Sie, welche zusätzlich per E-Mail gesendet werden.',
  'preferences.emailDigest': 'E-Mail-Zusammenfassung',
  'preferences.dailySummary': 'Eine tägliche Zusammenfassung statt einer E-Mail für jedes Ereignis erhalten.',
  'preferences.digestOff': 'Aus — E-Mail für jedes Ereignis',
  'preferences.digestDaily': 'Tägliche Zusammenfassung',
  'preferences.emailNotifications': 'E-Mail-Benachrichtigungen',
  'activities.button': 'Letzte Aktivitäten',
  'activities.title': 'Letzte Aktivitäten',
  'activities.loadError': 'Letzte Aktivitäten konnten nicht geladen werden.',
  'activities.systemActor': 'System',
  'activities.noneTitle': 'Noch keine aktuellen Aktivitäten',
  'activities.noneDescription': 'Ticket-Updates von Ihnen und Ihrer Gruppe werden hier angezeigt, sobald sie eintreten.',
  'tickets.title': 'Tickets',
  'tickets.description': 'Alle Tickets, auf die Sie Zugriff haben, gefiltert und sortiert nach Ihren Anforderungen.',
  'tickets.dueDateTabs': 'Ticket-Fälligkeitsdatum',
  'tickets.tabAll': 'Alle Tickets',
  'tickets.tabDueToday': 'Heute fällig',
  'tickets.tabOverdue': 'Überfällig',
  'tickets.tabDueTomorrow': 'Morgen fällig',
  'tickets.searchPlaceholder': 'Tickets durchsuchen…',
  'tickets.searchAria': 'Tickets durchsuchen',
  'tickets.filters': 'Filter',
  'tickets.filtersWithCount': 'Filter ({count})',
  'tickets.sortAria': 'Tickets sortieren nach',
  'tickets.sortTrigger': 'Sortieren: {label}',
  'tickets.sortDateCreated': 'Erstellungsdatum',
  'tickets.sortDateUpdated': 'Aktualisierungsdatum',
  'tickets.sortPriority': 'Priorität',
  'tickets.sortStatus': 'Status',
  'tickets.sortDueDate': 'Fälligkeitsdatum',
  'tickets.sortAscending': 'Aufsteigend sortieren',
  'tickets.sortDescending': 'Absteigend sortieren',
  'tickets.ascending': 'Aufsteigend',
  'tickets.descending': 'Absteigend',
  'tickets.layoutAria': 'Zeilenlayout',
  'tickets.layoutTrigger': 'Layout: {label}',
  'tickets.layoutCard': 'Karte',
  'tickets.layoutInbox': 'Posteingang',
  'tickets.layoutTable': 'Tabelle',
  'tickets.export': 'Exportieren',
  'tickets.exportSelected': 'Auswahl exportieren',
  'tickets.selectedCount': '{count} ausgewählt',
  'tickets.assignAgent': 'Agent zuweisen',
  'tickets.closeAll': 'Alle schließen',
  'tickets.clearSelection': 'Auswahl aufheben',
  'tickets.selectAgentPlaceholder': 'Agent auswählen...',
  'tickets.assignTo': 'Zuweisen an',
  'tickets.assign': 'Zuweisen',
  'tickets.loadFailed': 'Tickets konnten nicht geladen werden. Bitte erneut versuchen.',
  'tickets.bulkCloseFailed': 'Die ausgewählten Tickets konnten nicht geschlossen werden. Bitte erneut versuchen.',
  'tickets.bulkAssignFailed': 'Die ausgewählten Tickets konnten nicht zugewiesen werden. Bitte erneut versuchen.',
  'tickets.noFilterMatchTitle': 'Keine Tickets entsprechen diesen Filtern',
  'tickets.noFilterMatchDescription': 'Entfernen Sie einen Filter, erweitern Sie den Zeitraum oder suchen Sie nach einem anderen Begriff.',
  'tickets.clearFilters': 'Filter zurücksetzen',
  'tickets.queueClearTitle': 'Diese Warteschlange ist leer',
  'tickets.queueClearDescription': 'Neue Tickets werden hier angezeigt, sobald Kunden eine E-Mail senden, das Portal nutzen oder ein Agent eines erstellt.',
  'tickets.newTicket': 'Neues Ticket',
  'tickets.selectAllAria': 'Alle Tickets auswählen',
  'tickets.selectTicketAria': 'Ticket Nr. {number} auswählen',
  'tickets.columnContact': 'Kontakt',
  'tickets.columnSubject': 'Betreff',
  'tickets.columnState': 'Status',
  'tickets.columnGroup': 'Gruppe',
  'tickets.columnAgent': 'Agent',
  'tickets.columnPriority': 'Priorität',
  'tickets.noGroup': 'Keine Gruppe',
  'tickets.unassigned': 'Nicht zugewiesen',
  'tickets.createdRelative': 'Erstellt {when}',
  'tickets.unassignedOnly': 'Nur nicht zugewiesene',
  'tickets.unknownRequester': 'Unbekannter Anfragender',
  'tickets.overdueBy': 'Überfällig um {duration}',
  'tickets.dueIn': 'Fällig in {duration}',
  'tickets.filtersDrawerTitle': 'Filter',
  'tickets.filtersSearchPlaceholder': 'Felder durchsuchen',
  'tickets.filtersSearchAria': 'Filterfelder durchsuchen',
  'tickets.filtersClearAll': 'Alle zurücksetzen',
  'tickets.filtersApply': 'Anwenden',
  'tickets.filterAgents': 'Agenten',
  'tickets.filterAnyAgent': 'Beliebiger Agent',
  'tickets.filterGroups': 'Gruppen',
  'tickets.filterAnyGroup': 'Beliebige Gruppe',
  'tickets.filterStatus': 'Status',
  'tickets.filterAnyStatus': 'Beliebiger Status',
  'tickets.filterPriority': 'Priorität',
  'tickets.filterAnyPriority': 'Beliebige Priorität',
  'tickets.filterSource': 'Quelle',
  'tickets.filterAnySource': 'Beliebige Quelle',
  'tickets.filterTicketType': 'Ticket-Typ',
  'tickets.filterAnyType': 'Beliebiger Typ',
  'tickets.filterTags': 'Tags',
  'tickets.filterAnyTag': 'Beliebiges Tag',
  'tickets.filterCompanies': 'Unternehmen',
  'tickets.filterAnyCompany': 'Beliebiges Unternehmen',
  'tickets.filterCreated': 'Erstellt',
  'tickets.filterResolvedAt': 'Gelöst am',
  'tickets.filterClosedAt': 'Geschlossen am',
  'tickets.filterDateFrom': '{label} von',
  'tickets.filterDateTo': '{label} bis',
  'tickets.filterDateTo2': 'bis',
  'tickets.filterAny': 'Beliebig',
  'tickets.chipFieldStatus': 'Status',
  'tickets.chipFieldPriority': 'Priorität',
  'tickets.chipFieldGroup': 'Gruppe',
  'tickets.chipFieldAssignee': 'Zuständiger',
  'tickets.chipValueGroup': 'Gruppe',
  'tickets.chipValueUnassigned': 'Nicht zugewiesen',
  'common.clearSearch': 'Suche löschen',
  'common.name': 'Name',
  'common.role': 'Rolle',
  'common.groups': 'Gruppen',
  'common.tickets': 'Tickets',
  'common.lastSeen': 'Zuletzt gesehen',
  'common.actions': 'Aktionen',
  'common.minutesAgo': 'vor {count} Min.',
  'common.hoursAgo': 'vor {count} Std.',
  'common.daysAgo': 'vor {count} Tg.',
  'common.noPagePermission': 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
  'common.roleNoPermission': 'Ihre Rolle hat keine Berechtigung, auf diese Seite zuzugreifen.',
  'common.requestFailed': 'Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'common.unexpectedError': 'Ein unerwarteter Fehler ist aufgetreten',
  'shell.skipToMain': 'Zum Hauptinhalt springen',
  'shell.homeLabel': 'Suzuki Support Desk Startseite',
  'shell.userMenu': 'Benutzermenü',
  'shell.unread': '{count} ungelesen',
  'shell.notificationDescription': 'Neue Zuweisungen, Antworten und SLA-Warnungen werden hier angezeigt.',
  'auth.enterAuthenticatorCode': 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein',
  'auth.verifying': 'Wird überprüft…',
  'auth.setupAuthenticator': 'Authenticator einrichten',
  'auth.scanAuthenticator': 'Scannen Sie diesen Code mit Ihrer Authenticator-App (Google Authenticator, Authy usw.)',
  'auth.authenticatorSetupQr': 'QR-Code zur Authenticator-Einrichtung',
  'auth.verificationCodeFromAuthenticator': 'Bestätigungscode aus dem Authenticator',
  'auth.verifyAndComplete': 'Bestätigen und Einrichtung abschließen',
  'auth.loadingSetup': 'Einrichtung wird geladen…',
  'auth.setNewPassword': 'Neues Passwort festlegen',
  'auth.temporaryPasswordExpired': 'Ihr temporäres Passwort ist abgelaufen. Bitte legen Sie ein neues Passwort fest.',
  'auth.newPassword': 'Neues Passwort',
  'auth.confirmPassword': 'Passwort bestätigen',
  'auth.settingPassword': 'Passwort wird festgelegt…',
  'auth.setPassword': 'Passwort festlegen',
  'auth.passwordRequirements': 'Mindestens 8 Zeichen, Groß-/Kleinbuchstaben, Zahl und Symbol erforderlich',
  'auth.tooManyAttempts': 'Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut.',
  'auth.invalidCredentials': 'Ungültige E-Mail oder Passwort',
  'auth.passwordsDoNotMatch': 'Passwörter stimmen nicht überein',
  'auth.passwordMinimum': 'Das Passwort muss mindestens {count} Zeichen lang sein',
  'auth.resetTitle': 'Setzen Sie Ihr Passwort zurück',
  'auth.resetSubtitle': 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen',
  'auth.checkEmail': 'Prüfen Sie Ihre E-Mails auf einen Link zum Zurücksetzen',
  'auth.checkCode': 'Prüfen Sie Ihre E-Mails auf den Bestätigungscode und fahren Sie dann unten fort.',
  'auth.continueToReset': 'Mit dem Zurücksetzen des Passworts fortfahren',
  'auth.sendResetLink': 'Link zum Zurücksetzen senden',
  'auth.sending': 'Wird gesendet…',
  'auth.resetSuccess': 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
  'auth.goToLogin': 'Zur Anmeldung',
  'auth.missingResetToken': 'Fehlendes Reset-Token. Bitte verwenden Sie den Link aus Ihrer E-Mail.',
  'auth.enterCodeFromEmail': 'Geben Sie den an Ihre E-Mail gesendeten Bestätigungscode ein',
  'auth.codeFromEmail': 'Code aus E-Mail eingeben',
  'auth.emailRequired': 'E-Mail ist erforderlich',
  'auth.codeRequired': 'Bestätigungscode ist erforderlich',
  'auth.missingToken': 'Fehlendes Reset-Token',
  'auth.failedReset': 'Zurücksetzen des Passworts fehlgeschlagen.',
  'auth.resetting': 'Wird zurückgesetzt…',
  'auth.resetPassword': 'Passwort zurücksetzen',
  'auth.looksGood': 'Sieht gut aus',
  'auth.needCharacters': 'Mindestens {count} Zeichen erforderlich',
  'auth.passwordFormat': 'Mindestens {count} Zeichen, Groß-/Kleinbuchstaben, Zahl und Symbol erforderlich',
  'agents.description': 'Personen, die Tickets bearbeiten. Weisen Sie eine Rolle zu, um festzulegen, was sie tun können, und Gruppen, um festzulegen, was sie sehen.',
  'agents.searchAria': 'Agenten suchen',
  'agents.countOne': '{count} Agent',
  'agents.countMany': '{count} Agenten',
  'agents.ticketOne': '{count} Ticket',
  'agents.ticketMany': '{count} Tickets',
  'agents.noGroups': 'Keine Gruppen',
  'agents.lifecycle': 'Agenten-Lebenszyklus',
  'agents.tryDifferent': 'Versuchen Sie einen anderen Namen oder eine andere E-Mail-Adresse.',
  'agents.useNewAgent': 'Verwenden Sie „Neuer Agent“, um jemanden hinzuzufügen, oder wechseln Sie die Tabs, um andere Agenten zu sehen.',
  'agents.agent': 'Agent',
  'agents.noRole': 'Keine Rolle',
  'agents.openTicketsTitle': 'Offene Tickets, die derzeit diesem Agenten zugewiesen sind',
  'agents.moreActions': 'Weitere Aktionen für {name}',
  'agents.confirmDeleteTitle': '{name} löschen?',
  'agents.confirmDeleteDescription': 'Dies kann nicht widerrufen werden. Agenten, die mit Tickets verknüpft sind, können nicht gelöscht werden; deaktivieren Sie diese statt.',
  'agents.confirmDeleteLabel': 'Agent löschen',
  'agents.agentsVsCollaborators': 'Agenten vs. Mitarbeiter',
  'agents.agentsVsCollaboratorsBody': 'Support-Agenten bearbeiten Tickets im Tagesgeschäft. Mitarbeiter haben eine Mitarbeiterrolle und sind in der Regel Fachexperten, die für einzelne Tickets ohne vollen Agentenzugriff hinzugezogen werden.',
  'agents.deactivateVsDelete': 'Deaktivieren vs. Löschen',
  'agents.deactivateVsDeleteBody': 'Deaktivieren behält Verlauf und Ticket-Zuordnung, blockiert aber die Anmeldung. Löschen ist endgültig und funktioniert nur, wenn der Agent keine verknüpften Tickets hat.',
  'agents.newTitle': 'Neuer Agent',
  'agents.editTitle': 'Agent bearbeiten',
  'agents.temporaryPassword': 'Temporäres Passwort',
  'agents.passwordHelp': 'Mindestens 12 Zeichen. Der Agent kann dies nach der Anmeldung ändern.',
  'agents.timezoneHelp': 'Jedes Datum und jede Uhrzeit, die dieser Agent sieht, wird in dieser Zeitzone angezeigt.',
  'agents.languageHelp': 'Übersetzt die agentenseitige Oberfläche. Ticketantworten und Kundeninhalte werden nicht übersetzt.',
  'agents.signaturePlaceholder': 'Wird an ausgehende Antworten angehängt',
  'agents.roleHelp': 'Bestimmt, was dieser Agent tun kann.',
  'agents.manageRoles': 'Rollen verwalten',
  'agents.activeHelp': 'Aktiv — durch Deaktivieren wird die Anmeldung blockiert, ohne den Agenten zu löschen',
  'agents.groupHelp': 'Fügen Sie diesen Agenten über den Gruppenbildschirm zu einer Gruppe hinzu, um festzulegen, welche Tickets er sieht.',
  'agents.about': 'Über diesen Agenten',
  'agents.aboutBody': 'Name, E-Mail, Telefon, Zeitzone, Sprache und Signatur identifizieren den Agenten und personalisieren seinen Arbeitsbereich. Die Rolle bestimmt, was er tun kann; die Gruppenmitgliedschaft bestimmt, welche Tickets er sieht.',
  'dashboard.trendsDescription': 'Ticketerstellung nach UTC-Stunde, verglichen mit gestern.',
  'dashboard.chartAria': 'Ticketvolumen nach UTC-Stunde, heute im Vergleich zu gestern',
  'dashboard.dataUnavailable': 'Dashboard-Daten sind nicht verfügbar.',
  'dashboard.loadError': 'Dashboard-Daten konnten nicht geladen werden. Bitte erneut versuchen.',
  'notifications.noType': 'Keine Benachrichtigungen dieses Typs',
  'notifications.allTypesHint': 'Wählen Sie oben „Alle Typen“, um den Rest Ihrer Historie zu sehen.',
  'notifications.emptyDescription': 'Zuweisungen, Antworten und SLA-Warnungen landen hier. Passen Sie in den Benachrichtigungseinstellungen an, welche davon Ihnen per E-Mail zugesendet werden.',
  'preferences.digestWarning': 'Sie nutzen die tägliche Zusammenfassung, daher werden diese Einstellungen ignoriert, bis Sie sie deaktivieren.',
  'preferences.assignedEvent': 'Ein Ticket wird Ihnen zugewiesen',
  'preferences.replyEvent': 'Ein Ticket, an dem Sie beteiligt sind, erhält eine Antwort',
  'preferences.noteEvent': 'Eine private Notiz wird hinzugefügt',
  'preferences.slaWarningEvent': 'SLA nähert sich der Frist',
  'preferences.slaBreachEvent': 'SLA wurde verletzt',
  'preferences.slaEscalationEvent': 'SLA eskaliert über die Frist hinaus',
  'preferences.mentionEvent': 'Sie werden in einem Ticket erwähnt',

  'ticketDetail.back': 'Zurück',
  'ticketDetail.follow': 'Folgen',
  'ticketDetail.following': 'Folgt',
  'ticketDetail.hideActivities': 'Aktivitäten ausblenden',
  'ticketDetail.activitiesButton': 'Aktivitäten',
  'ticketDetail.attachmentsCount': 'Anhänge ({count})',
  'ticketDetail.threadAria': 'Ticket-Verlauf',
  'ticketDetail.conversationsTabLabel': 'Konversationen',
  'ticketDetail.activitiesTabLabel': 'Aktivitäten',
  'ticketDetail.noRepliesYet': 'Noch keine Antworten',
  'ticketDetail.noRepliesDescription': 'Verwenden Sie den Editor unten, um dem Anfragenden zu antworten oder eine interne Notiz hinzuzufügen.',
  'ticketDetail.privateNote': 'Private Notiz',
  'ticketDetail.forward': 'Weiterleitung',
  'ticketDetail.uploadingAria': 'Wird hochgeladen',
  'ticketDetail.uploadingProgress': '{uploading} von {total} Datei(en) werden hochgeladen…',
  'ticketDetail.uploadsFailed': '{count} Upload(s) fehlgeschlagen',
  'ticketDetail.retry': 'Erneut versuchen',
  'ticketDetail.dismiss': 'Verwerfen',
  'ticketDetail.noActivityYet': 'Noch keine Aktivität',
  'ticketDetail.noActivityDescription': 'Status-, Agenten- und SLA-Änderungen werden hier aufgeführt, sobald sich das Ticket bewegt.',
  'ticketDetail.requester': 'Anfragender',
  'ticketDetail.properties': 'Eigenschaften',
  'ticketDetail.updating': 'Wird aktualisiert…',
  'ticketDetail.update': 'Aktualisieren',
  'ticketDetail.tags': 'Tags',
  'ticketDetail.relationships': 'Beziehungen',
  'ticketDetail.parentTicket': 'Übergeordnetes Ticket',
  'ticketDetail.unlink': 'Verknüpfung aufheben',
  'ticketDetail.noParentTicket': 'Kein übergeordnetes Ticket',
  'ticketDetail.childTicketsCount': 'Untergeordnete Tickets ({count})',
  'ticketDetail.noChildTickets': 'Keine untergeordneten Tickets',
  'ticketDetail.findTicket': 'Ticket finden',
  'ticketDetail.ticketSearchPlaceholder': 'Ticketnummer oder Betreff',
  'ticketDetail.searchButton': 'Suchen',
  'ticketDetail.setParent': 'Als übergeordnet festlegen',
  'ticketDetail.mergeIntoAction': 'Zusammenführen mit',
  'ticketDetail.splitIntoChild': 'In untergeordnetes Ticket aufteilen',
  'ticketDetail.newTicketSubjectPlaceholder': 'Betreff des neuen Tickets',
  'ticketDetail.splitButton': 'Aufteilen',
  'ticketDetail.copyAttachments': 'Anhänge kopieren',
  'ticketDetail.copyConversationHistory': 'Konversationsverlauf kopieren',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'Pausiert',
  'ticketDetail.editButton': 'Bearbeiten',
  'ticketDetail.setResolutionDueDate': 'Lösungsfrist festlegen',
  'ticketDetail.pickDateTime': 'Datum & Uhrzeit wählen',
  'ticketDetail.resolutionDueLabel': 'Lösungsfrist',
  'ticketDetail.saveSla': 'SLA speichern',
  'ticketDetail.savingSla': 'Wird gespeichert…',
  'ticketDetail.noSlaPolicy': 'Für dieses Ticket ist keine SLA-Richtlinie festgelegt.',
  'ticketDetail.firstResponse': 'Erste Antwort',
  'ticketDetail.resolution': 'Lösung',
  'ticketDetail.done': 'Erledigt',
  'ticketDetail.pausedSince': 'Pausiert seit {date}',
  'ticketDetail.escalation': 'Eskalation',
  'ticketDetail.escalatedLevel2': 'Eskaliert (Stufe 2)',
  'ticketDetail.escalated': 'Eskaliert',
  'ticketDetail.dueDateOverridden': 'Fälligkeitsdatum manuell von einem Administrator überschrieben.',
  'ticketDetail.dates': 'Termine',
  'ticketDetail.created': 'Erstellt',
  'ticketDetail.updated': 'Aktualisiert',
  'ticketDetail.resolved': 'Gelöst',
  'ticketDetail.closed': 'Geschlossen',
  'ticketDetail.loadErrorTitle': 'Dieses Ticket konnte nicht geladen werden',
  'ticketDetail.notFound': 'Ticket nicht gefunden',
  'ticketDetail.confirmMergeTitle': 'Ticket Nr. {source} mit Nr. {target} zusammenführen?',
  'ticketDetail.confirmMergeDescription': 'Das aktuelle Ticket wird geschlossen. Dies kann nicht widerrufen werden.',
  'ticketDetail.confirmMergeLabel': 'Ticket zusammenführen',
  'ticketDetail.updateSuccess': 'Ticket aktualisiert',
  'ticketDetail.updateError': 'Ticket konnte nicht aktualisiert werden',
  'ticketDetail.pickDateTitle': 'Datum wählen',
  'ticketDetail.pickDateDescription': 'Wählen Sie eine Lösungsfrist.',
  'ticketDetail.slaUpdateSuccess': 'SLA aktualisiert',
  'ticketDetail.slaUpdateError': 'SLA konnte nicht aktualisiert werden',
  'ticketDetail.searchError': 'Tickets konnten nicht durchsucht werden',
  'ticketDetail.parentUpdateError': 'Übergeordnetes Ticket konnte nicht aktualisiert werden',
  'ticketDetail.mergeSuccess': 'Zusammengeführt mit Nr. {number}',
  'ticketDetail.mergeError': 'Ticket konnte nicht zusammengeführt werden',
  'ticketDetail.splitSuccess': 'Ticket-Aufteilung erstellt',
  'ticketDetail.splitError': 'Ticket konnte nicht aufgeteilt werden',
  'ticketDetail.downloadError': 'Anhang konnte nicht heruntergeladen werden',
  'ticketDetail.followSuccess': 'Ticket wird jetzt verfolgt',
  'ticketDetail.unfollowSuccess': 'Ticket wird nicht mehr verfolgt',
  'ticketDetail.watcherError': 'Beobachterstatus konnte nicht aktualisiert werden',
  'ticketDetail.fieldsLoadError': 'Ticketfelder konnten nicht geladen werden',
  'ticketDetail.overdueBy': '{label} überfällig',
  'ticketDetail.dueLeft': '{label} verbleibend',
  'ticketDetail.presetToday': 'Heute',
  'ticketDetail.presetTomorrow': 'Morgen',
  'ticketDetail.presetThisWeek': 'Diese Woche',
  'ticketDetail.presetNextWeek': 'Nächste Woche',
  'ticketDetail.presetThisMonth': 'Dieser Monat',
  'ticketDetail.eventTicketCreated': 'Ticket erstellt',
  'ticketDetail.eventStatusUpdated': 'Status aktualisiert',
  'ticketDetail.eventAgentUpdated': 'Agent aktualisiert',
  'ticketDetail.eventSlaUpdated': 'SLA aktualisiert',
  'ticketDetail.eventTicketMerged': 'Ticket zusammengeführt',
  'ticketDetail.eventMergeReceived': 'Zusammenführung empfangen',
  'ticketDetail.eventTicketSplit': 'Ticket aufgeteilt',
  'ticketDetail.eventUpdated': 'Aktualisiert',
  'ticketDetail.eventSplitContentCopied': 'Aufgeteilter Inhalt kopiert',
  'ticketDetail.eventReplySent': 'Antwort gesendet',
  'ticketDetail.eventNoteAdded': 'Notiz hinzugefügt',
  'ticketDetail.eventCustomerReplied': 'Kunde hat geantwortet',
  'ticketDetail.eventTicketDeleted': 'Ticket gelöscht',
  'preferences.createdEvent': 'Ein Ticket wurde erstellt',
  'preferences.pendingInputEvent': 'Ein Ticket wartet auf Ihre Antwort',
  'preferences.resolvedEvent': 'Ein Ticket wurde gelöst',
  'agents.assignGroups': 'Gruppen zuweisen',
  'agents.assignGroupsHelp': 'Die Gruppenmitgliedschaft bestimmt, welche Tickets dieser Agent sehen kann.',
  'agents.selectGroups': 'Gruppen auswählen',
  'agents.ticketVisibility': 'Ticketsichtbarkeit',
  'agents.ticketVisibilityHelp': 'Wählen Sie eine engere Grenze pro Agent oder übernehmen Sie den Rollenstandard. Rollenberechtigungen bestimmen weiterhin, was der Agent tun darf.',
  'agents.scopeRoleDefault': 'Rollenstandard verwenden',
  'agents.scopeRoleDefaultHelp': 'Die für diese Rolle konfigurierte Standardsichtbarkeit übernehmen.',
  'agents.scopeAll': 'Alle Tickets',
  'agents.scopeAllHelp': 'Alle nicht gelöschten Tickets in diesem Konto anzeigen.',
  'agents.scopeGroup': 'Tickets in einer Gruppe',
  'agents.scopeGroupHelp': 'Tickets anzeigen, die Gruppen zugewiesen sind, denen dieser Agent angehört.',
  'agents.scopeAssigned': 'Zugewiesene Tickets',
  'agents.scopeAssignedHelp': 'Tickets anzeigen, die diesem Agenten direkt zugewiesen sind.',
  'agents.scopeCollaboratorHelp': 'Mitarbeiter bleiben auf Tickets in ihren L1-Gruppen beschränkt.',
  'nav.jira': 'Jira-Integration',
  'notifications.groupAssigned': 'Gruppenzuweisung',
  'notifications.groupMemberAdded': 'Zur Gruppe hinzugefügt',
  'preferences.groupAssignedEvent': 'Ein Ticket wird einer Ihrer Gruppen zugewiesen',
  'preferences.groupMemberAddedEvent': 'Sie werden zu einer Support-Gruppe hinzugefügt',
  'ui.select': 'Auswählen…',
  'ui.any': 'Beliebig',
  'ui.typeToSearch': 'Zum Suchen eingeben…',
  'ui.noResults': 'Keine Ergebnisse gefunden',
  'ui.clearSelection': 'Auswahl aufheben',
  'ui.removeItem': '{label} entfernen',
  'ui.pressEnterToUse': 'Eingabetaste drücken, um diesen Wert zu verwenden',
  'ui.removeFilter': 'Filter {field}: {value} entfernen',
  'ui.removeTag': 'Tag {label} entfernen',
  'ui.retry': 'Erneut versuchen',
  'ui.errorTitle': 'Dieser Inhalt konnte nicht geladen werden',
  'ui.errorMessage': 'Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'ui.reference': 'Referenz: {id}',
  'ui.thisArea': 'dieser Bereich',
  'ui.noAccess': 'Sie haben keinen Zugriff auf {area}',
  'ui.noAccessHint': 'Bitten Sie einen Administrator, die erforderliche Berechtigung zu erteilen.',
  'ui.actionFailed': 'Diese Aktion konnte nicht abgeschlossen werden. Versuchen Sie es erneut.',
  'ui.slaPaused': 'SLA pausiert',
  'ui.filteredEmptyTitle': 'Keine Tickets entsprechen diesen Filtern',
  'ui.filteredEmptyDescription': 'Entfernen Sie einen Filter oder erweitern Sie den Datumsbereich.',
  'ui.clearFilters': 'Filter zurücksetzen',
  'pagination.noResults': 'Keine Ergebnisse',
  'pagination.showing': '{first}–{last} von {total} werden angezeigt',
  'pagination.resultsPerPage': 'Ergebnisse pro Seite',
  'pagination.perPage': '{count} pro Seite',
  'pagination.previous': 'Zurück',
  'pagination.next': 'Weiter',
  'pagination.previousAria': 'Vorherige Seite',
  'pagination.nextAria': 'Nächste Seite',
  'pagination.pageOf': 'Seite {page} von {total}',
  'status.open': 'Offen',
  'status.to_be_prioritised': 'Zu priorisieren',
  'status.work_in_progress': 'In Bearbeitung',
  'status.assigned_to_ai_agent': 'KI-Agent zugewiesen',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Ausstehend',
  'status.awaiting_user_reply': 'Wartet auf Antwort des Benutzers',
  'status.awaiting_resolution_confirmation': 'Wartet auf Lösungsbestätigung',
  'status.on_hold': 'Zurückgestellt',
  'status.pending_production_release': 'Wartet auf Produktivfreigabe',
  'status.product_cr': 'Produkt-CR',
  'status.reopened': 'Wieder geöffnet',
  'status.issue_fixed': 'Problem behoben',
  'status.resolved': 'Gelöst',
  'status.closed': 'Geschlossen',
  'status.unknown': 'Unbekannt',
  'priority.low': 'Niedrig',
  'priority.medium': 'Mittel',
  'priority.high': 'Hoch',
  'priority.urgent': 'Dringend',
  'source.email': 'E-Mail',
  'source.portal': 'Portal',
  'source.phone': 'Telefon',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Web-Chat',
  'source.web_form': 'Webformular',
  'source.forum': 'Forum',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Feedback-Widget',
  'source.outbound_email': 'Ausgehende E-Mail',
  'source.ecommerce': 'E-Commerce',
  'source.bot': 'Bot',
  'source.instagram_message': 'Instagram-Nachricht',
  'source.instagram_comment': 'Instagram-Kommentar',
  'source.facebook_message': 'Facebook-Nachricht',
  'source.facebook_comment': 'Facebook-Kommentar',
  'source.mobile_chat_sdk': 'Mobile Chat SDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Gespeicherte Ansichten',
  'savedViews.saveCurrent': 'Aktuelle Filter als Ansicht speichern',
  'savedViews.namePlaceholder': 'Name der Ansicht...',
  'savedViews.nameAria': 'Name der Ansicht',
  'savedViews.empty': 'Keine gespeicherten Ansichten. Wenden Sie Filter an und speichern Sie sie hier.',
  'savedViews.listAria': 'Liste der gespeicherten Ansichten',
  'savedViews.rename': 'Ansicht „{name}“ umbenennen',
  'savedViews.delete': 'Ansicht „{name}“ löschen',
  'export.title': 'Tickets exportieren',
  'export.loadError': 'Die Liste der Exportfelder konnte nicht geladen werden.',
  'export.failed': 'Export fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'export.pdfFailed': 'PDF-Export fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'export.fieldsSelectedOne': '{count} Feld ausgewählt',
  'export.fieldsSelectedMany': '{count} Felder ausgewählt',
  'export.fieldsTotalOne': '{count} Feld insgesamt',
  'export.fieldsTotalMany': '{count} Felder insgesamt',
  'export.selectAllFields': 'Alle Felder auswählen',
  'export.exportingOne': '1 ausgewähltes Ticket wird exportiert.',
  'export.exportingMany': '{count} ausgewählte Tickets werden exportiert.',
  'export.pdfZip': 'Als PDF herunterladen (.zip, {count} Dateien)',
  'export.pdf': 'Als PDF herunterladen',
  'export.pdfZipHint': 'Erstellt ein PDF pro Ticket und komprimiert alle in einen einzigen ZIP-Download.',
  'export.pdfHint': 'Erstellt ein einzelnes PDF mit den Ticket-Eigenschaften und dem öffentlichen Konversationsverlauf.',
  'export.formatLabel': 'Exportieren als (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Feldliste wird geladen…',
  'export.ticketFields': 'Ticket-Felder',
  'export.contactFields': 'Kontaktfelder',
  'export.companyFields': 'Unternehmensfelder',
  'export.exporting': 'Exportiere…',
  'newTicket.title': 'Ticket erstellen',
  'newTicket.description': 'Wählen Sie ein gespeichertes Formular und füllen Sie die Felder aus.',
  'newTicket.form': 'Ticket-Formular',
  'newTicket.noForms': 'Keine Ticket-Formulare verfügbar. Konfigurieren Sie ein Formular, bevor Sie ein Ticket erstellen.',
  'newTicket.loadFormsError': 'Ticket-Formulare konnten nicht geladen werden',
  'newTicket.loadFormError': 'Das ausgewählte Ticket-Formular konnte nicht geladen werden',
  'newTicket.addCc': 'CC hinzufügen',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': '{name} entfernen',
  'newTicket.requesterRequired': 'Anfragender ist erforderlich',
  'newTicket.subjectRequired': 'Betreff ist erforderlich',
  'newTicket.createFailed': 'Ticket konnte nicht erstellt werden',
  'newTicket.noFormTitle': 'Kein Ticket-Formular verfügbar',
  'newTicket.noFormDescription': 'Erstellen Sie in den Einstellungen ein Ticket-Formular und kehren Sie dann zurück, um ein Ticket zu öffnen.',
  'newTicket.noFieldsTitle': 'Dieses Formular enthält noch keine Felder',
  'newTicket.noFieldsDescription': 'Fügen Sie dem Formular in den Einstellungen Felder hinzu und laden Sie die Seite neu.',
  'newTicket.creating': 'Wird erstellt...',
  'newTicket.submit': 'Ticket erstellen',
  'fields.required': '{label} ist erforderlich',
  'fields.selectParentFirst': 'Zuerst einen übergeordneten Wert auswählen...',
  'fields.selectPlaceholder': '{label} auswählen...',
  'fields.enterPlaceholder': '{label} eingeben...',
  'fields.optionsLoadError': 'Optionen für {label} konnten nicht geladen werden',
  'fields.label.requester': 'Anfragender',
  'fields.label.subject': 'Betreff',
  'fields.label.description': 'Beschreibung',
  'fields.label.status': 'Status',
  'fields.label.priority': 'Priorität',
  'fields.label.source': 'Quelle',
  'fields.label.ticket_type': 'Typ',
  'fields.label.agent': 'Agent',
  'fields.label.group': 'Gruppe',
  'fields.label.internal_agent': 'Interner Agent',
  'fields.label.internal_group': 'Interne Gruppe',
  'fields.label.company': 'Unternehmen',
  'editor.defaultPlaceholder': 'Hier eingeben...',
  'editor.ariaLabel': 'Rich-Text-Editor',
  'editor.toolbarAria': 'Textformatierung',
  'editor.bold': 'Fett (Strg+B)',
  'editor.italic': 'Kursiv (Strg+I)',
  'editor.underline': 'Unterstrichen (Strg+U)',
  'editor.strikethrough': 'Durchgestrichen',
  'editor.heading1': 'Überschrift 1',
  'editor.heading2': 'Überschrift 2',
  'editor.textColor': 'Textfarbe',
  'editor.highlight': 'Hervorheben',
  'editor.bulletList': 'Aufzählungsliste',
  'editor.numberedList': 'Nummerierte Liste',
  'editor.blockquote': 'Zitat',
  'editor.codeBlock': 'Codeblock',
  'editor.insertLink': 'Link einfügen',
  'editor.insertImage': 'Bild einfügen',
  'editor.insertTable': 'Tabelle einfügen',
  'editor.mention': 'Jemanden erwähnen',
  'editor.undo': 'Rückgängig (Strg+Z)',
  'editor.redo': 'Wiederholen (Strg+Umschalt+Z)',
  'editor.attach': 'Datei anhängen',
  'editor.noAgents': 'Keine Agenten gefunden',
  'editor.mentionSuggestions': 'Erwähnungsvorschläge',
  'editor.dialogLinkTitle': 'Link einfügen',
  'editor.dialogImageTitle': 'Bild einfügen',
  'editor.linkHint': 'Geben Sie eine HTTP(S)-, mailto-, Anker- oder relative URL ein.',
  'editor.imageHint': 'Geben Sie eine HTTP(S)- oder relative Bild-URL ein.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Geben Sie eine gültige HTTP(S)-, mailto-, Anker- oder relative URL ein.',
  'editor.invalidImage': 'Geben Sie eine gültige HTTP(S)- oder relative Bild-URL ein.',
  'editor.selectTextForLink': 'Wählen Sie Text aus, bevor Sie einen Link hinzufügen.',
  'editor.imageInsertFailed': 'Das Bild konnte hier nicht eingefügt werden.',
  'editor.insertLinkAction': 'Link einfügen',
  'editor.insertImageAction': 'Bild einfügen',
  'search.dialogAria': 'Globale Suche',
  'search.placeholder': 'Tickets, Kontakte suchen...',
  'search.aria': 'Suchen',
  'search.close': 'Suche schließen',
  'search.noMatches': 'Keine Treffer für „{query}“',
  'search.noMatchesHint': 'Versuchen Sie eine Ticketnummer, eine Kontakt-E-Mail oder einen Unternehmensnamen.',
  'search.hintBefore': 'Geben Sie mindestens 2 Zeichen ein, um zu suchen. Drücken Sie',
  'search.hintAfter': 'zum Schließen.',

  'td.system': 'System',
  'td.actionCreatedTicket': 'hat das Ticket erstellt',
  'td.actionUpdatedFields': 'hat {fields} aktualisiert',
  'td.fieldStatus': 'Status',
  'td.fieldPriority': 'Priorität',
  'td.fieldSource': 'Quelle',
  'td.fieldType': 'Typ',
  'td.fieldGroup': 'Gruppe',
  'td.fieldAgent': 'Agent',
  'td.fieldCompany': 'Unternehmen',
  'td.fieldContact': 'Kontakt',
  'td.fieldSubject': 'Betreff',
  'td.fieldDescription': 'Beschreibung',
  'td.fieldProduct': 'Produkt',
  'td.fieldResolutionDue': 'Lösungsfälligkeit',
  'td.fieldFirstResponseDue': 'Fälligkeit der ersten Antwort',
  'td.fieldTags': 'Tags',
  'td.fieldParentTicket': 'übergeordnetes Ticket',
  'td.eventCreated': '{actor} hat ein neues Ticket erstellt',
  'td.eventCreatedLinked': '{actor} hat ein neues Ticket erstellt und mit einem übergeordneten Ticket verknüpft',
  'td.eventSplit': '{actor} hat dieses Ticket aufgeteilt und das untergeordnete Ticket{ref} erstellt',
  'td.eventMergeReceived': '{actor} hat ein anderes Ticket in dieses Ticket zusammengeführt{ref}',
  'td.eventMerged': '{actor} hat dieses Ticket in ein anderes Ticket zusammengeführt{ref}',
  'td.eventSplitCopied': '{actor} hat {conversations} und {attachments} kopiert',
  'td.conversationsOne': '{count} Konversation',
  'td.conversationsMany': '{count} Konversationen',
  'td.attachmentsOne': '{count} Anhang',
  'td.attachmentsMany': '{count} Anhänge',
  'td.eventUpdatedFields': '{actor} hat {fields} aktualisiert',
  'td.invalidSlaState': 'Der Server hat einen ungültigen SLA-Status zurückgegeben.',
  'td.slaRefreshError': 'SLA-Timer konnten nicht aktualisiert werden.',
  'td.descriptionUpdated': 'Beschreibung aktualisiert',
  'td.descriptionUpdateError': 'Beschreibung konnte nicht aktualisiert werden',
  'td.descriptionUpdateFailed': 'Aktualisierung der Beschreibung fehlgeschlagen',
  'td.entryUpdated': 'Eintrag aktualisiert',
  'td.entryUpdateError': 'Eintrag konnte nicht aktualisiert werden',
  'td.updateFailed': 'Aktualisierung fehlgeschlagen',
  'td.loadOlderError': 'Ältere Konversationen konnten nicht geladen werden',
  'td.loadFailed': 'Laden fehlgeschlagen',
  'td.slaUpdateFailed': 'SLA-Aktualisierung fehlgeschlagen',
  'td.reasonTooLong': 'Der Grund darf höchstens 500 Zeichen lang sein.',
  'td.invalidDateTime': 'Wählen Sie ein gültiges Datum und eine gültige Uhrzeit.',
  'td.slaDeadlineUpdated': 'SLA-Frist aktualisiert',
  'td.slaConflict': 'Das Ticket wurde geändert, während Sie die SLA-Daten bearbeitet haben. Laden Sie neu, bevor Sie es erneut versuchen.',
  'td.slaClearFailed': 'SLA konnte nicht zurückgesetzt werden',
  'td.slaTargetCleared': 'SLA-Ziel zurückgesetzt',
  'td.slaClearError': 'SLA-Ziel konnte nicht zurückgesetzt werden',
  'td.noDescription': 'Noch keine Beschreibung hinzugefügt.',
  'td.editDescriptionAria': 'Ticketbeschreibung bearbeiten',
  'td.download': 'Herunterladen',
  'td.downloadFile': '{fileName} herunterladen',
  'td.loadOlder': '↓ +{count} Konversation',
  'td.loadOlderMany': '↓ +{count} Konversationen',
  'td.edited': '(bearbeitet)',
  'td.privateThread': 'Privater Thread',
  'td.propertiesAria': 'Ticket-Eigenschaften',
  'td.expandProperties': 'Eigenschaften einblenden',
  'td.collapseProperties': 'Eigenschaften ausblenden',
  'td.metric': 'Metrik',
  'td.firstResponseOption': 'Erste Antwort',
  'td.resolutionOption': 'Lösung',
  'td.overrideHint': 'Legen Sie eine serverseitig maßgebliche Fristüberschreibung fest. Der Grund wird im SLA-Verlauf gespeichert.',
  'td.deadline': 'Frist',
  'td.reasonOptional': 'Grund (optional)',
  'td.reasonPlaceholder': 'Genehmigte Ausnahme oder betrieblicher Kontext',
  'td.clearResolutionOverride': 'Lösungsüberschreibung entfernen',
  'td.clearEscalationTarget': 'Eskalationsziel entfernen',
  'td.toolsAria': 'Ticket-Werkzeuge und Kontakt',
  'td.ticketContext': 'Ticketkontext',
  'td.knowledgeBase': 'Wissensdatenbank',
  'td.shortcutsAria': 'Verknüpfungen zum Ticketkontext',
  'td.showContext': 'Ticketkontext anzeigen',
  'td.hideContext': 'Ticketkontext ausblenden',
  'td.openRow': '{label} öffnen',
  'td.editTicket': 'Ticket bearbeiten',
  'td.searchContactPlaceholder': 'Kontakt suchen…',
  'td.describePlaceholder': 'Beschreiben Sie das Problem…',
  'td.noAttachments': 'Keine Anhänge',

  'tp.api.csrfUnavailable': 'CSRF-Schutz konnte nicht eingerichtet werden',
  'tp.api.noMfaChallenge': 'Keine MFA-Abfrage aktiv',
  'tp.api.noMfaSetup': 'Keine MFA-Einrichtung aktiv',
  'tp.api.noNewPasswordChallenge': 'Keine Abfrage für ein neues Passwort aktiv',
  'tp.articles.isLinkedAria': '{title} ist als Lösung verknüpft',
  'tp.articles.linkAria': '{title} als Lösung verknüpfen',
  'tp.articles.linkAsSolution': 'Als Lösung verknüpfen',
  'tp.articles.linkedAsSolution': 'Als Lösung verknüpft',
  'tp.articles.none': 'Keine vorgeschlagenen Artikel für dieses Ticket.',
  'tp.articles.title': 'Vorgeschlagene Artikel',
  'tp.articles.views': '{count} Aufrufe',
  'tp.attachment.loadingPreview': 'Vorschau wird geladen…',
  'tp.attachment.previewUnavailable': 'Vorschau nicht verfügbar',
  'tp.charts.noData': 'Keine Diagrammdaten für diesen Zeitraum.',
  'tp.charts.noRecords': 'Keine Datensätze in diesem Zeitraum.',
  'tp.charts.period': 'Zeitraum',
  'tp.charts.showingTop': 'Es werden die obersten {shown} von {total} Segmenten angezeigt.',
  'tp.common.cancel': 'Abbrechen',
  'tp.common.clear': 'Zurücksetzen',
  'tp.common.loading': 'Wird geladen…',
  'tp.common.send': 'Senden',
  'tp.common.sending': 'Wird gesendet…',
  'tp.common.system': 'System',
  'tp.convActions.edit': 'Bearbeiten',
  'tp.convActions.thread': 'Thread starten',
  'tp.dashboard.new': 'Neu',
  'tp.dashboard.select': 'Dashboard auswählen',
  'tp.forward.failed': 'Weiterleiten fehlgeschlagen',
  'tp.forward.forwarded': 'Ticket weitergeleitet',
  'tp.forward.forwarding': 'Wird weitergeleitet…',
  'tp.forward.forwardingMany': '{count} Konversationen werden weitergeleitet:',
  'tp.forward.forwardingOne': '1 Konversation wird weitergeleitet:',
  'tp.forward.message': 'Nachricht',
  'tp.forward.messagePlaceholder': 'Nachricht hinzufügen (optional)…',
  'tp.forward.noContacts': 'Keine Kontakte gefunden – geben Sie eine vollständige E-Mail-Adresse ein',
  'tp.forward.recipientEmail': 'E-Mail des Empfängers',
  'tp.forward.recipientInvalid': 'Geben Sie eine gültige E-Mail-Adresse des Empfängers ein',
  'tp.forward.recipientRequired': 'Die E-Mail des Empfängers ist erforderlich',
  'tp.forward.searchContact': 'Kontakt suchen oder E-Mail eingeben…',
  'tp.forward.title': 'Weiterleiten',
  'tp.forward.to': 'An',
  'tp.forward.useThisEmail': 'Drücken Sie die Eingabetaste oder klicken Sie auf Weiterleiten, um diese E-Mail zu verwenden',
  'tp.jira.addOptional': 'Optionale Felder hinzufügen',
  'tp.jira.createAndLink': 'Issue erstellen und verknüpfen',
  'tp.jira.createIssue': 'Issue erstellen',
  'tp.jira.createTitle': 'Jira-Issue erstellen',
  'tp.jira.describePlaceholder': 'Beschreiben Sie das Problem…',
  'tp.jira.description': 'Beschreibung',
  'tp.jira.development': 'Entwicklung',
  'tp.jira.enterDevelopment': 'Entwicklung eingeben',
  'tp.jira.hideOptional': 'Optionale Felder ausblenden',
  'tp.jira.issueId': 'Issue-ID',
  'tp.jira.issueSummary': 'Issue-Zusammenfassung',
  'tp.jira.issueType': 'Issue-Typ *',
  'tp.jira.lastSync': 'Letzte Synchronisierung: {error}',
  'tp.jira.linkIssue': 'Issue verknüpfen',
  'tp.jira.linkTitle': 'Jira-Issue verknüpfen',
  'tp.jira.linkedIssues': 'Verknüpfte Issues',
  'tp.jira.linkedIssuesHint': 'Verwenden Sie Jira-Issue-Schlüssel, durch Kommas getrennt.',
  'tp.jira.linkedIssuesPlaceholder': 'z. B. SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Jira-Felder werden geladen…',
  'tp.jira.loadingIssueTypes': 'Issue-Typen werden geladen…',
  'tp.jira.loadingProjects': 'Jira-Projekte werden geladen…',
  'tp.jira.loadingUsers': 'Jira-Benutzer werden geladen…',
  'tp.jira.noLinks': 'Diesem Ticket sind noch keine Jira-Issues zugeordnet.',
  'tp.jira.noneFound': 'Keine Jira-Issues gefunden.',
  'tp.jira.notAvailableProject': 'Für dieses Projekt nicht verfügbar',
  'tp.jira.projects': 'Projekte *',
  'tp.jira.refresh': 'Aktualisieren',
  'tp.jira.refreshFields': 'Jira-Felder aktualisieren',
  'tp.jira.reporter': 'Melder',
  'tp.jira.requestFailed': 'Jira-Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'tp.jira.searchBy': 'Suchen nach:',
  'tp.jira.searchIssue': 'Issue suchen',
  'tp.jira.searchIssuePlaceholder': 'Issue suchen…',
  'tp.jira.searchUsers': 'Jira-Benutzer suchen',
  'tp.jira.searching': 'Jira wird durchsucht…',
  'tp.jira.selectIssueType': 'Issue-Typ auswählen',
  'tp.jira.selectProject': 'Projekt auswählen',
  'tp.jira.summary': 'Zusammenfassung *',
  'tp.jira.syncOff': 'Synchronisierung aus',
  'tp.jira.syncOn': 'Synchronisierung ein',
  'tp.jira.syncStatus': 'Ticketstatus mit Jira synchronisieren',
  'tp.jira.unassigned': 'Nicht zugewiesen',
  'tp.jira.unlink': 'Verknüpfung aufheben',
  'tp.jira.unlinkConfirm': 'Issue-Verknüpfung aufheben',
  'tp.jira.unlinkDescription': 'Dadurch wird die Verbindung zum Ticket entfernt, das Jira-Issue wird jedoch nicht gelöscht.',
  'tp.jira.unlinkTitle': 'Verknüpfung mit {key} aufheben?',
  'tp.jira.untitled': 'Jira-Issue ohne Titel',
  'tp.layout.loadingPage': 'Seite wird geladen…',
  'tp.notFound.goToDashboard': 'Zum Dashboard',
  'tp.notFound.title': 'Seite nicht gefunden',
  'tp.portal.brand': 'SuzukiDesk Support',
  'tp.portal.customer': 'Kunde',
  'tp.reply.addNote': 'Notiz hinzufügen',
  'tp.reply.attachmentNotAdded': 'Anhang nicht hinzugefügt',
  'tp.reply.clickToExpand': 'Zum Erweitern klicken',
  'tp.reply.collapsedNote': 'Interne Notiz hinzufügen…',
  'tp.reply.collapsedReply': 'Antwort oder Notiz schreiben…',
  'tp.reply.conversationType': 'Konversationstyp',
  'tp.reply.failedToSend': 'Senden fehlgeschlagen',
  'tp.reply.markNoteAs': 'Notiz markieren als',
  'tp.reply.notVisibleToContact': 'Für den Kontakt nicht sichtbar',
  'tp.reply.notVisibleToContacts': 'Für Kontakte nicht sichtbar',
  'tp.reply.noteAdded': 'Notiz hinzugefügt',
  'tp.reply.notifyTo': 'Benachrichtigen',
  'tp.reply.placeholderPrivateNote': 'Private Notiz hinzufügen...',
  'tp.reply.placeholderPublicNote': 'Öffentliche Notiz hinzufügen, die für den Anfragenden sichtbar ist...',
  'tp.reply.placeholderReply': 'Antwort eingeben...',
  'tp.reply.private': 'Privat',
  'tp.reply.public': 'Öffentlich',
  'tp.reply.removeFile': '{name} entfernen',
  'tp.reply.replySent': 'Antwort gesendet',
  'tp.reply.searchAgentsToNotify': 'Agenten zum Benachrichtigen suchen…',
  'tp.reply.sendReply': 'Antwort senden',
  'tp.reply.sending': 'Wird gesendet...',
  'tp.reply.tabNote': 'Notiz',
  'tp.reply.tabReply': 'Antwort',
  'tp.reply.uploadAttachment': 'Anhang hochladen',
  'tp.reply.visibleToContact': 'Für den Kontakt sichtbar',
  'tp.reply.visibleToContacts': 'Für Kontakte sichtbar',
  'tp.sla.breached': 'Verletzt',
  'tp.sla.cleared': 'Zurückgesetzt',
  'tp.sla.configErrorNoDeadline': 'SLA-Konfigurationsfehler. Es wird keine Frist abgeleitet.',
  'tp.sla.configurationError': 'Konfigurationsfehler',
  'tp.sla.couldNotLoad': 'SLA-Timer konnten nicht geladen werden',
  'tp.sla.done': 'Erledigt',
  'tp.sla.dueIn': 'Fällig in {duration}',
  'tp.sla.dueLine': 'Fällig: {date}',
  'tp.sla.dueNow': 'Jetzt fällig',
  'tp.sla.escalated': 'Eskaliert',
  'tp.sla.firstResponse': 'Erste Antwort',
  'tp.sla.invalidDeadline': 'Ungültige Frist',
  'tp.sla.mayBeStale': 'SLA-Timer sind möglicherweise veraltet',
  'tp.sla.noActiveCycle': 'Kein aktiver SLA-Zyklus.',
  'tp.sla.noDeadline': 'Keine Frist',
  'tp.sla.noMetrics': 'Für diesen Zyklus sind keine SLA-Metriken verfügbar.',
  'tp.sla.noPolicy': 'Für dieses Ticket gilt keine SLA-Richtlinie.',
  'tp.sla.notConfigured': 'Nicht konfiguriert',
  'tp.sla.notStarted': 'Nicht gestartet',
  'tp.sla.overdueBy': 'Überfällig seit {duration}',
  'tp.sla.overridden': 'Überschrieben',
  'tp.sla.overrideReason': 'Grund der Überschreibung: {reason}',
  'tp.sla.paused': 'Pausiert',
  'tp.sla.refreshing': 'Maßgebliche SLA-Timer werden aktualisiert…',
  'tp.sla.resolution': 'Lösung',
  'tp.sla.stopsSla': 'Stoppt SLA',
  'tp.thread.empty': 'Es wurde noch nichts gesendet. Ihre erste Nachricht startet diesen privaten Thread.',
  'tp.thread.messageFailed': 'Nachricht fehlgeschlagen',
  'tp.thread.privateThread': 'Privater Thread',
  'tp.thread.replyPlaceholder': 'Im Thread antworten…',
  'tp.thread.someone': 'Jemand',
  'tp.thread.startPrivateThread': 'Privaten Thread starten',
  'tp.thread.startedBy': '{name} hat diesen Thread gestartet',
  'tp.thread.unableToSend': 'Nachricht konnte nicht gesendet werden',
  'tp.ui.breadcrumb': 'Brotkrümelnavigation',
  'tp.ui.closePanel': 'Bereich schließen',
  'tp.ui.dismiss': '{title} schließen',

  'dir.loadError': 'Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
  'dir.contacts.description': 'Kundenkontakte und ihr Support-Verlauf.',
  'dir.contacts.searchAria': 'Kontakte durchsuchen',
  'dir.contacts.count': '{count} Kontakte',
  'dir.contacts.noMatch': 'Keine Kontakte entsprechen dieser Suche',
  'dir.contacts.none': 'Noch keine Kontakte',
  'dir.contacts.noneDescription': 'Kontakte erscheinen hier, sobald Kunden Tickets einreichen.',
  'dir.company': 'Unternehmen',
  'dir.unnamedContact': 'Kontakt ohne Namen',
  'dir.contact': 'Kontakt',
  'dir.contactNotFound': 'Kontakt nicht gefunden.',
  'dir.confirmDeleteContactTitle': '„{name}“ löschen?',
  'dir.thisContact': 'diesen Kontakt',
  'dir.confirmDeleteContactDescription': 'Kontakte mit Tickets werden deaktiviert, statt dauerhaft gelöscht zu werden.',
  'dir.deleteContact': 'Kontakt löschen',
  'dir.editProfile': 'Profil bearbeiten',
  'dir.profile': 'Profil',
  'dir.firstName': 'Vorname',
  'dir.lastName': 'Nachname',
  'dir.phone': 'Telefon',
  'dir.timezone': 'Zeitzone',
  'dir.emailLabel': 'E-Mail:',
  'dir.phoneLabel': 'Telefon:',
  'dir.companyLabel': 'Unternehmen:',
  'dir.timezoneLabel': 'Zeitzone:',
  'dir.recentTickets': 'Letzte Tickets',
  'dir.noTicketsYet': 'Noch keine Tickets',
  'dir.contactTicketsDescription': 'Tickets dieses Kontakts werden hier aufgelistet.',
  'dir.ticket': 'Ticket',
  'dir.subject': 'Betreff',
  'dir.status': 'Status',
  'dir.created': 'Erstellt',
  'dir.companies.description': 'Organisationen, die mit Kundenkontakten und Tickets verknüpft sind.',
  'dir.companies.add': 'Unternehmen hinzufügen',
  'dir.companies.domain': 'Domain',
  'dir.companies.create': 'Unternehmen erstellen',
  'dir.companies.searchAria': 'Unternehmen durchsuchen',
  'dir.companies.searchPlaceholder': 'Unternehmen oder Domains suchen',
  'dir.companies.noMatch': 'Keine Unternehmen entsprechen dieser Suche',
  'dir.companies.addFirst': 'Ihr erstes Unternehmen hinzufügen',
  'dir.companies.tryDifferent': 'Versuchen Sie einen anderen Unternehmensnamen oder eine andere Domain.',
  'dir.companies.useForm': 'Verwenden Sie das Formular neben dieser Liste, um ein Unternehmen zu erstellen.',
  'dir.companies.contacts': 'Kontakte',
  'dir.companies.tickets': 'Tickets',
  'dir.companies.notFound': 'Unternehmen nicht gefunden.',
  'dir.companies.confirmDeleteTitle': '„{name}“ löschen?',
  'dir.companies.thisCompany': 'dieses Unternehmen',
  'dir.companies.confirmDeleteDescription': 'Das Unternehmen darf keine Kontakte oder Tickets haben, bevor es gelöscht werden kann.',
  'dir.companies.delete': 'Unternehmen löschen',
  'dir.companies.noDomain': 'Keine Domain konfiguriert',
  'dir.companies.contactsCount': 'Kontakte ({count})',
  'dir.companies.ticketsCount': 'Tickets ({count})',
  'dir.companies.noContactsDescription': 'Fügen Sie einen Kontakt hinzu und verknüpfen Sie ihn mit diesem Unternehmen, damit er hier erscheint.',
  'dir.companies.noTicketsDescription': 'Tickets von Kontakten dieses Unternehmens werden hier aufgelistet.',
  'dir.trendsCreatedHour': 'Erstellungsdatum – Tagesstunde',
  'dir.reports.loadError': 'Dieser Bericht konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
  'dir.reports.volume': 'Ticketvolumen',
  'dir.reports.sla': 'SLA-Einhaltung',
  'dir.reports.agents': 'Agentenleistung',
  'dir.reports.csat': 'Kundenzufriedenheit',
  'dir.reports.rca': 'Ursachenanalyse',
  'dir.reports.descVolume': 'Sehen Sie, woher Tickets kommen und wie sie den Lebenszyklus durchlaufen.',
  'dir.reports.descSla': 'Verfolgen Sie Antwort- und Lösungsziele im gesamten zugänglichen Support-Betrieb.',
  'dir.reports.descAgents': 'Vergleichen Sie Auslastung, Ergebnisse, Antworten und durchschnittliche Bearbeitungszeiten je Agent.',
  'dir.reports.descCsat': 'Erfassen Sie die Kundenstimmung, ohne die Anzahl der Antworten mit der Zufriedenheitsrate zu verwechseln.',
  'dir.reports.descRca': 'Finden Sie die standardisierten Ursachen hinter dem Ticketaufkommen.',
  'dir.reports.noPayload': 'Für diesen Zeitraum wurden keine Berichtsdaten zurückgegeben.',
  'dir.reports.refresh': 'Aktualisieren',
  'dir.reports.report': 'Bericht',
  'dir.reports.from': 'Von',
  'dir.reports.to': 'Bis',
  'dir.reports.maxRange': 'Maximaler Zeitraum: 90 Tage · der Umfang richtet sich nach Ihren Kontoberechtigungen.',
  'dir.reports.unclassified': 'Nicht klassifiziert',
  'dir.reports.ticketsInPeriod': 'Tickets im Zeitraum',
  'dir.reports.ticketsInPeriodDetail': 'Zugängliche Tickets, die der Bericht zurückgegeben hat',
  'dir.reports.created': 'Erstellt',
  'dir.reports.createdDetail': 'Über die gewählte Datumsachse',
  'dir.reports.resolved': 'Gelöst',
  'dir.reports.resolvedDetail': '{percent} % des erstellten Volumens',
  'dir.reports.noCreated': 'Keine erstellten Tickets',
  'dir.reports.reopened': 'Wieder geöffnet',
  'dir.reports.reopenedDetail': 'Lebenszyklus-Ereignisse, keine eindeutigen Tickets',
  'dir.reports.dailyPulse': 'Tagesverlauf',
  'dir.reports.volumeByDate': 'Ticketvolumen nach Datum',
  'dir.reports.volumeByDateDescription': 'Lückenhafte Backend-Zeilen werden zu einer vollständigen, mit Nullen aufgefüllten Datumsachse erweitert.',
  'dir.reports.createdTickets': 'Erstellte Tickets',
  'dir.reports.createdVolumeAria': 'Volumen erstellter Tickets nach Datum',
  'dir.reports.lifecycle': 'Lebenszyklus',
  'dir.reports.lifecycleTitle': 'Erstellt, gelöst, wieder geöffnet',
  'dir.reports.lifecycleDescription': 'Eine Dreilinienansicht der Bewegung durch den Ticket-Lebenszyklus.',
  'dir.reports.lifecycleAria': 'Ticket-Lebenszyklus-Ereignisse nach Datum',
  'dir.reports.dimensions': 'Dimensionen',
  'dir.reports.whereConcentrated': 'Wo sich das Volumen konzentriert',
  'dir.reports.topEight': 'Pro Bereich werden die acht größten Segmente angezeigt',
  'dir.reports.status': 'Status',
  'dir.reports.statusDescription': 'Aktueller Ticketstatus',
  'dir.reports.priority': 'Priorität',
  'dir.reports.priorityDescription': 'Verteilung der Ticketprioritäten',
  'dir.reports.group': 'Gruppe',
  'dir.reports.groupDescription': 'Routing-Gruppen',
  'dir.reports.agent': 'Agent',
  'dir.reports.agentDescription': 'Zugewiesene Zuständigkeit',
  'dir.reports.product': 'Produkt',
  'dir.reports.productDescription': 'Produktverteilung',
  'dir.reports.country': 'Land',
  'dir.reports.countryDescription': 'Aus standardisierten Länderfeldern',
  'dir.reports.noRecords': 'Keine Datensätze in diesem Zeitraum.',
  'dir.reports.slaSummary': '{rate} · {met} von {total} erfüllt',
  'dir.reports.noSlaSegments': 'Noch keine SLA-Segmente',
  'dir.reports.noSlaSegmentsDescription': 'Für diese Dimension gibt es im gewählten Zeitraum keine anwendbaren SLA-Datensätze.',
  'dir.reports.segment': 'Segment',
  'dir.reports.firstResponse': 'Erste Antwort',
  'dir.reports.resolution': 'Lösung',
  'dir.reports.avgFirstResponse': 'Ø erste Antwort',
  'dir.reports.avgResolution': 'Ø Lösung',
  'dir.reports.fromTicketMetric': 'Aus TicketMetric',
  'dir.reports.slaLens': 'SLA-Perspektive',
  'dir.reports.performanceBySegment': 'Leistung nach Segment',
  'dir.reports.slaRatesNote': 'Die Raten berücksichtigen nur Datensätze mit anwendbarem SLA-Ziel. Dauern sind durchschnittlich verstrichene Zeiten.',
  'dir.reports.slaDimensionAria': 'Dimension der SLA-Aufschlüsselung',
  'dir.reports.rosterSignal': 'Teamübersicht',
  'dir.reports.agentPerformance': 'Agentenleistung',
  'dir.reports.agentPerformanceDescription': 'Jeder aktive Agent ist enthalten, auch Agenten ohne Aktivität.',
  'dir.reports.filterAgentsAria': 'Agenten filtern',
  'dir.reports.filterAgentsPlaceholder': 'Nach Agent oder E-Mail filtern',
  'dir.reports.matchingAgents': '{count} passende Agenten',
  'dir.reports.activeAgents': '{count} aktive Agenten',
  'dir.reports.sortedBy': 'sortiert nach {key} {direction}',
  'dir.reports.asc': 'aufsteigend',
  'dir.reports.desc': 'absteigend',
  'dir.reports.noAgentsMatch': 'Keine Agenten entsprechen diesem Filter',
  'dir.reports.assigned': 'Zugewiesen',
  'dir.reports.replies': 'Antworten',
  'dir.reports.csatScore': 'CSAT-Wert',
  'dir.reports.csatScoreDetail': 'Bewertungen von 4 oder 5',
  'dir.reports.averageRating': 'Durchschnittsbewertung',
  'dir.reports.averageRatingDetail': 'Über bewertete Umfragen',
  'dir.reports.ratedSurveys': 'Bewertete Umfragen',
  'dir.reports.ratedSurveysDetail': 'Im gewählten Zeitraum',
  'dir.reports.satisfied': 'Zufrieden',
  'dir.reports.satisfiedDetail': 'Positive Antworten',
  'dir.reports.responseTrend': 'Antworttrend',
  'dir.reports.surveyVolume': 'Umfragevolumen nach Datum',
  'dir.reports.surveyVolumeDescription': 'Das Backend liefert die Anzahl der Antworten pro Datum; dies ist kein Tageswert. Unten wird eine Stichprobe der letzten 100 Antworten gezeigt.',
  'dir.reports.surveyResponses': 'Umfrageantworten',
  'dir.reports.surveyVolumeAria': 'Volumen der CSAT-Umfrageantworten nach Datum',
  'dir.reports.responsesByGroup': 'Antworten nach Gruppe',
  'dir.reports.responsesByGroupDescription': 'Anzahl der Umfrageantworten, keine Zufriedenheitsrate der Gruppe',
  'dir.reports.responsesByAgent': 'Antworten nach Agent',
  'dir.reports.responsesByAgentDescription': 'Anzahl der Umfrageantworten, keine Zufriedenheitsrate des Agenten',
  'dir.reports.customerVoice': 'Kundenstimme',
  'dir.reports.latestSurveys': 'Neueste Umfrageantworten',
  'dir.reports.boundedSample': 'Begrenzte Stichprobe · {count} von max. 100',
  'dir.reports.latestSurveysNote': 'Neueste Antworten, die von der Reporting-API zurückgegeben wurden. Nutzen Sie diese Tabelle für einen schnellen Überblick, nicht als vollständigen Export.',
  'dir.reports.noSurveys': 'Keine Umfrageantworten',
  'dir.reports.noSurveysDescription': 'CSAT-Antworten erscheinen hier, sobald Kunden ein gelöstes Ticket bewerten.',
  'dir.reports.rating': 'Bewertung',
  'dir.reports.comment': 'Kommentar',
  'dir.reports.received': 'Eingegangen',
  'dir.reports.ratingOutOf': '{rating} von 5',
  'dir.reports.noComment': 'Kein Kommentar',
  'dir.reports.rcaEyebrow': 'Ursachenanalyse',
  'dir.reports.rcaTitle': 'Warum Tickets erstellt werden',
  'dir.reports.rcaDescription': 'Kategorie und Unterkategorie sind unabhängige Aggregate der standardisierten benutzerdefinierten Ticketfelder.',
  'dir.reports.rcaDimensionAria': 'RCA-Dimension',
  'dir.reports.category': 'Kategorie',
  'dir.reports.subcategory': 'Unterkategorie',
  'dir.reports.rcaEmpty': 'Für diesen Zeitraum wurden keine Ursachenwerte erfasst.',
  'dir.kb.articleLoadError': 'Der Artikel konnte nicht geladen werden.',
  'dir.kb.articleNotFound': 'Artikel nicht gefunden.',
  'dir.kb.retry': 'Erneut versuchen',
  'dir.kb.title': 'Wissensdatenbank',
  'dir.kb.breadcrumb': 'Wissensdatenbank',
  'dir.kb.description': '{articles} Artikel in {folders} Ordnern',
  'dir.kb.newArticle': 'Neuer Artikel',
  'dir.kb.editArticle': 'Artikel bearbeiten',
  'dir.kb.sectionsAria': 'Bereiche der Wissensdatenbank',
  'dir.kb.tabArticles': 'Artikel',
  'dir.kb.tabStructure': 'Kategorien & Ordner',
  'dir.kb.folderFilterAria': 'Ordnerfilter',
  'dir.kb.allArticles': 'Alle Artikel ({count})',
  'dir.kb.writeFirst': 'Schreiben Sie Ihren ersten Artikel',
  'dir.kb.writeFirstDescription': 'Mit „Neuer Artikel“ fügen Sie diesem Ordner Inhalte hinzu.',
  'dir.kb.byAuthor': 'von {name}',
  'dir.kb.views': '{count} Aufrufe',
  'dir.kb.published': 'Veröffentlicht',
  'dir.kb.draft': 'Entwurf',
  'dir.kb.publish': 'Veröffentlichen',
  'dir.kb.unpublish': 'Veröffentlichung zurückziehen',
  'dir.kb.noFolders': 'Keine Ordner in dieser Kategorie',
  'dir.kb.noFoldersDescription': 'Fügen Sie einen Ordner hinzu, um Artikel zu gruppieren.',
  'dir.kb.articlesCount': '{count} Artikel',
  'dir.kb.fieldTitle': 'Titel',
  'dir.kb.folder': 'Ordner',
  'dir.kb.selectFolder': 'Ordner auswählen',
  'dir.kb.content': 'Inhalt',
  'dir.kb.contentPlaceholder': 'Schreiben Sie den Inhalt Ihres Artikels...',
  'dir.kb.tags': 'Tags (durch Kommas getrennt)',
  'dir.kb.attachments': 'Anhänge',
  'dir.kb.download': 'Herunterladen',
  'dir.kb.downloadFile': '{name} herunterladen',
  'dir.kb.remove': 'Entfernen',
  'dir.kb.removeFile': '{name} entfernen',
  'dir.kb.noAttachments': 'Noch keine Anhänge.',
  'dir.kb.uploadAria': 'Anhang hochladen',
  'dir.kb.uploading': 'Wird hochgeladen...',
  'dir.kb.addFile': 'Datei hinzufügen',
  'dir.kb.confirmDeleteTitle': 'Artikel löschen?',
  'dir.kb.confirmDeleteDescription': 'Dieser veröffentlichte oder als Entwurf gespeicherte Artikel wird dauerhaft gelöscht.',
  'dir.kb.confirmDeleteLabel': 'Artikel löschen',
  'dir.kb.confirmRemoveTitle': 'Anhang entfernen?',
  'dir.kb.confirmRemoveDescription': 'Die Datei wird dauerhaft aus diesem Artikel entfernt.',
  'dir.kb.confirmRemoveLabel': 'Anhang entfernen',
  'dir.reports.rangeInvalid': 'Wählen Sie gültige Start- und Enddaten.',
  'dir.reports.rangeOrder': 'Das Enddatum muss am oder nach dem Startdatum liegen.',
  'dir.reports.rangeMax': 'Berichte unterstützen einen maximalen Zeitraum von 90 Tagen.',

  'adm.active': 'Aktiv',
  'adm.auto.action.add_tag': 'Tag hinzufügen',
  'adm.auto.action.assign_agent': 'Agent zuweisen',
  'adm.auto.action.assign_group': 'Gruppe zuweisen',
  'adm.auto.action.send_email': 'E-Mail senden',
  'adm.auto.action.send_notification': 'Benachrichtigung senden',
  'adm.auto.action.set_priority': 'Priorität festlegen',
  'adm.auto.action.set_status': 'Status festlegen',
  'adm.auto.actions': 'Aktionen',
  'adm.auto.addAction': '+ Aktion hinzufügen',
  'adm.auto.addCondition': '+ Bedingung hinzufügen',
  'adm.auto.addRule': 'Regel hinzufügen',
  'adm.auto.colApplied': 'Angewendete Aktionen',
  'adm.auto.colDate': 'Datum',
  'adm.auto.colMatched': 'Zutreffend',
  'adm.auto.colSubject': 'Betreff',
  'adm.auto.colTicket': 'Ticket',
  'adm.auto.conditions': 'Bedingungen',
  'adm.auto.confirmDesc': 'Diese Regel wird sofort nicht mehr ausgeführt und kann nicht wiederhergestellt werden.',
  'adm.auto.confirmLabel': 'Regel löschen',
  'adm.auto.confirmTitle': 'Automatisierungsregel löschen?',
  'adm.auto.countMany': '{count} Automatisierungsregeln',
  'adm.auto.countOne': '{count} Automatisierungsregel',
  'adm.auto.create': 'Erstellen',
  'adm.auto.createFirst': 'Erstellen Sie Ihre erste Automatisierungsregel',
  'adm.auto.createFirstDesc': 'Mit „Regel hinzufügen“ können Sie Tickets automatisch weiterleiten, priorisieren oder Benachrichtigungen senden.',
  'adm.auto.deleteFailed': 'Löschen fehlgeschlagen',
  'adm.auto.description': 'Regeln werden nacheinander nach Position ausgeführt. Bedingungen innerhalb einer Regel sind UND-verknüpft.',
  'adm.auto.editRule': 'Automatisierungsregel bearbeiten',
  'adm.auto.execFailed': 'Ausführungen konnten nicht geladen werden',
  'adm.auto.field.assigneeId': 'Bearbeiter',
  'adm.auto.field.companyId': 'Unternehmen',
  'adm.auto.field.groupId': 'Gruppe',
  'adm.auto.field.priority': 'Priorität',
  'adm.auto.field.requesterId': 'Anfragender',
  'adm.auto.field.source': 'Quelle',
  'adm.auto.field.status': 'Status',
  'adm.auto.field.subject': 'Betreff',
  'adm.auto.field.ticketTypeId': 'Tickettyp',
  'adm.auto.hits': 'Treffer',
  'adm.auto.loadFailed': 'Automatisierungsregeln konnten nicht geladen werden',
  'adm.auto.log': 'Protokoll',
  'adm.auto.logTitle': 'Ausführungsprotokoll – {name}',
  'adm.auto.moveDown': 'Nach unten',
  'adm.auto.moveUp': 'Nach oben',
  'adm.auto.newRule': 'Neue Automatisierungsregel',
  'adm.auto.no': 'Nein',
  'adm.auto.noRuns': 'Noch keine Ausführungen aufgezeichnet',
  'adm.auto.noRunsDesc': 'Ausführungen erscheinen hier, sobald diese Regel zum ersten Mal auf ein Ticket zutrifft.',
  'adm.auto.op.contains': 'enthält',
  'adm.auto.op.ends_with': 'endet mit',
  'adm.auto.op.greater_than': 'größer als',
  'adm.auto.op.in': 'in',
  'adm.auto.op.is': 'ist',
  'adm.auto.op.is_empty': 'ist leer',
  'adm.auto.op.is_not': 'ist nicht',
  'adm.auto.op.is_not_empty': 'ist nicht leer',
  'adm.auto.op.less_than': 'kleiner als',
  'adm.auto.op.not_contains': 'enthält nicht',
  'adm.auto.op.not_in': 'nicht in',
  'adm.auto.op.starts_with': 'beginnt mit',
  'adm.auto.reorderFailed': 'Neuanordnung fehlgeschlagen',
  'adm.auto.saveFailed': 'Speichern fehlgeschlagen',
  'adm.auto.stopProcessing': 'Nachfolgende Regeln nicht mehr verarbeiten',
  'adm.auto.title': 'Automatisierungsregeln',
  'adm.auto.toggleFailed': 'Umschalten fehlgeschlagen',
  'adm.auto.trigger': 'Auslöser *',
  'adm.auto.trigger.ticket_creation': 'Ticket-Erstellung',
  'adm.auto.trigger.ticket_update': 'Ticket-Aktualisierung',
  'adm.auto.trigger.time_trigger': 'Zeitbasiert',
  'adm.auto.triggerCol': 'Auslöser',
  'adm.auto.valuePlaceholder': 'Wert',
  'adm.auto.yes': 'Ja',
  'adm.close': 'Schließen',
  'adm.deleting': 'Wird gelöscht...',
  'adm.description': 'Beschreibung',
  'adm.descriptionLabel': 'Beschreibung',
  'adm.edit': 'Bearbeiten',
  'adm.email.addChannel': 'Kanal hinzufügen',
  'adm.email.addTitle': 'E-Mail-Kanal hinzufügen',
  'adm.email.colEmail': 'E-Mail',
  'adm.email.colReplyTo': 'Antwortadresse',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Dieser Kanal steht für Support-E-Mails nicht mehr zur Verfügung.',
  'adm.email.confirmLabel': 'Kanal löschen',
  'adm.email.confirmTitle': 'E-Mail-Kanal löschen?',
  'adm.email.countMany': '{count} E-Mail-Kanäle',
  'adm.email.countOne': '{count} E-Mail-Kanal',
  'adm.email.create': 'Erstellen',
  'adm.email.createFirst': 'Fügen Sie Ihren ersten E-Mail-Kanal hinzu',
  'adm.email.createFirstDesc': 'Mit „Kanal hinzufügen“ verbinden Sie eine Support-Adresse, damit Antworten diesen Desk erreichen.',
  'adm.email.default': 'Standard',
  'adm.email.defaultChannel': 'Standardkanal',
  'adm.email.deleteFailed': 'Löschen fehlgeschlagen',
  'adm.email.description': 'Verwalten Sie eingehende und ausgehende E-Mail-Adressen, die SMTP-Konfiguration und Antwortadressen.',
  'adm.email.editTitle': 'E-Mail-Kanal bearbeiten',
  'adm.email.emailAddress': 'E-Mail-Adresse *',
  'adm.email.loadFailed': 'E-Mail-Konfigurationen konnten nicht geladen werden',
  'adm.email.outbound': 'Ausgehendes SMTP',
  'adm.email.replyTo': 'Antwortadresse',
  'adm.email.replyToPh': '(standardmäßig die E-Mail-Adresse)',
  'adm.email.saveFailed': 'Speichern fehlgeschlagen',
  'adm.email.sesGlobal': 'SES (global)',
  'adm.email.smtpHost': 'SMTP-Host',
  'adm.email.smtpHostPh': 'z. B. email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'SMTP-Passwort',
  'adm.email.smtpPort': 'SMTP-Port',
  'adm.email.smtpUser': 'SMTP-Benutzer',
  'adm.email.title': 'E-Mail-Kanäle',
  'adm.groups.aboutBody': 'Mitglieder bestimmen, welche Agenten die Tickets dieser Gruppe standardmäßig sehen. Die Geschäftszeiten steuern das SLA-Timing für hierher weitergeleitete Tickets, und der Eskalationskontakt wird zusätzlich zum Bearbeiter benachrichtigt, wenn ein Ticket sein SLA verletzt.',
  'adm.groups.aboutTitle': 'Über diese Gruppe',
  'adm.groups.accountDefault': 'Kontostandard',
  'adm.groups.activeAgentMany': '{count} aktive Agenten',
  'adm.groups.activeAgentOne': '{count} aktiver Agent',
  'adm.groups.activeAgents': 'Aktive Agenten',
  'adm.groups.addMember': 'Mitglied hinzufügen',
  'adm.groups.assignment': 'Zuweisung',
  'adm.groups.autoAssign': 'Automatische Zuweisung',
  'adm.groups.autoAssignNote': 'Die Ticketzuweisung erfolgt in diesem Produkt immer manuell – es gibt kein Round-Robin- oder lastbasiertes Routing. Diese Option ändert daran nichts.',
  'adm.groups.businessHours': 'Geschäftszeiten',
  'adm.groups.colGroup': 'Gruppe',
  'adm.groups.confirmDesc': 'Tickets und Vorlagen, die diese Gruppe verwenden, müssen zuerst neu zugewiesen werden.',
  'adm.groups.confirmLabel': 'Gruppe löschen',
  'adm.groups.confirmTitle': '„{name}“ löschen?',
  'adm.groups.createFirst': 'Erstellen Sie Ihre erste Gruppe',
  'adm.groups.defaultHours': 'Standardzeiten',
  'adm.groups.editAria': '{name} bearbeiten',
  'adm.groups.editGroup': 'Gruppe bearbeiten',
  'adm.groups.escalateHelp': 'Wird als Benachrichtigungsempfänger hinzugefügt, wenn ein Ticket in dieser Gruppe sein SLA verletzt.',
  'adm.groups.escalateTo': 'Eskalieren an',
  'adm.groups.escalatesTo': 'Eskaliert an',
  'adm.groups.escalatesToName': 'Eskaliert an {name}',
  'adm.groups.escalationBody': 'Verletzt ein Ticket in dieser Gruppe sein SLA, wird der Eskalationskontakt zusätzlich zum Bearbeiter und den Gruppenmitgliedern als Benachrichtigungsempfänger hinzugefügt.',
  'adm.groups.escalationTitle': 'Eskalationskontakt',
  'adm.groups.hoursHelp': 'Wird für SLA-Berechnungen von Tickets in dieser Gruppe verwendet.',
  'adm.groups.manageAgents': 'Agenten verwalten',
  'adm.groups.manageHours': 'Geschäftszeiten verwalten',
  'adm.groups.manual': 'Manuell',
  'adm.groups.manualBody': 'Die Zuweisung erfolgt in diesem Produkt manuell – es gibt keine Round-Robin- oder lastbasierte automatische Zuweisung. Die Option „Automatische Zuweisung“ einer Gruppe bestimmt nur, ob neue Tickets in dieser Gruppe standardmäßig nicht zugewiesen bleiben oder auf eine bestehende Routing-Regel zurückfallen; Agenten übernehmen und übergeben Tickets weiterhin selbst.',
  'adm.groups.manualTitle': 'Manuelle Zuweisung',
  'adm.groups.memberMany': '{count} Mitglieder',
  'adm.groups.memberOne': '{count} Mitglied',
  'adm.groups.members': 'Mitglieder',
  'adm.groups.newGroup': 'Neue Gruppe',
  'adm.groups.noEscalation': 'Kein Eskalationskontakt',
  'adm.groups.noMatch': 'Keine Gruppen entsprechen dieser Suche',
  'adm.groups.noMembers': 'Noch keine Mitglieder',
  'adm.groups.noMembersDesc': 'Wählen Sie oben einen aktiven Agenten aus und klicken Sie auf „Mitglied hinzufügen“.',
  'adm.groups.remove': 'Entfernen',
  'adm.groups.routing': 'Routing',
  'adm.groups.routingMethod': 'Routing-Methode',
  'adm.groups.saved': 'Gruppe gespeichert.',
  'adm.groups.searchAria': 'Gruppen durchsuchen',
  'adm.groups.searchPlaceholder': 'Nach Name suchen',
  'adm.groups.selectActiveAgent': 'Aktiven Agenten auswählen',
  'adm.groups.showing': 'Zeige {start}–{end} von {total}',
  'adm.groups.subtitle': 'Gruppen steuern Ticket-Routing und Sichtbarkeit. Weisen Sie Agenten als Mitglieder zu und wählen Sie für jede Gruppe einen Geschäftszeitenplan und einen Eskalationskontakt.',
  'adm.groups.title': 'Gruppen',
  'adm.groups.tryDifferent': 'Versuchen Sie einen anderen Gruppennamen.',
  'adm.groups.unassigned': 'Nicht zugewiesen',
  'adm.groups.useNew': 'Mit „Neue Gruppe“ leiten Sie Tickets an eine Gruppe von Agenten weiter.',
  'adm.groups.zero': '0 Gruppen',
  'adm.inactive': 'Inaktiv',
  'adm.jira.accepted': 'Verbindung akzeptiert',
  'adm.jira.accountEmail': 'E-Mail des Jira-Kontos',
  'adm.jira.accountEmailLabel': 'Konto-E-Mail',
  'adm.jira.activeConn': 'Aktive Verbindung',
  'adm.jira.addConnection': 'Verbindung hinzufügen',
  'adm.jira.addTitle': 'Jira-Verbindung hinzufügen',
  'adm.jira.added': 'Jira-Verbindung hinzugefügt',
  'adm.jira.apiToken': 'API-Token',
  'adm.jira.clearSecret': 'Gespeichertes Webhook-Secret entfernen',
  'adm.jira.confirmDesc': 'Dadurch werden die gespeicherte Verbindung und ihre Ticketverknüpfungen entfernt. Jira-Issues werden nicht gelöscht.',
  'adm.jira.confirmLabel': 'Verbindung löschen',
  'adm.jira.confirmTitle': '{name} löschen?',
  'adm.jira.connName': 'Verbindungsname',
  'adm.jira.connNamePh': 'Engineering Jira',
  'adm.jira.connectedAs': 'Verbunden als {name}',
  'adm.jira.connectionDesk': 'Verbindungsübersicht',
  'adm.jira.default': 'Standard',
  'adm.jira.defaultConn': 'Standardverbindung',
  'adm.jira.defaultIssueType': 'Standard-Issue-Typ',
  'adm.jira.defaultProjectKey': 'Standard-Projektschlüssel',
  'adm.jira.defaults': 'Standardwerte',
  'adm.jira.description': 'Verbinden Sie kontoeigene Jira-Sites, damit Agenten Issues verknüpfen und den Ticketstatus synchron halten können.',
  'adm.jira.editTitle': 'Jira-Verbindung bearbeiten',
  'adm.jira.footer': 'Erstellen Sie den Jira-Webhook mit dem oben angezeigten Endpunkt, abonnieren Sie Ereignisse zu Issue-Aktualisierungen und verwenden Sie dasselbe hier konfigurierte Webhook-Secret.',
  'adm.jira.heading': 'Support und Entwicklung im selben Kreislauf halten',
  'adm.jira.intro': 'Zugangsdaten werden verschlüsselt auf dem Server gespeichert und nie an diese Ansicht zurückgegeben. Konfigurieren Sie ein Webhook-Secret, wenn Jira Statusänderungen an SuzukiDesk zurücksenden soll.',
  'adm.jira.no': 'Nein',
  'adm.jira.noConns': 'Noch keine Jira-Verbindungen',
  'adm.jira.noConnsDesc': 'Fügen Sie eine Verbindung hinzu, um Jira-Aktionen in der Ticketansicht verfügbar zu machen.',
  'adm.jira.noProject': 'Kein Projekt',
  'adm.jira.pasteToken': 'Token einfügen',
  'adm.jira.requestFailed': 'Jira-Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'adm.jira.savedToast': 'Jira-Verbindung gespeichert',
  'adm.jira.secretConfigured': 'Secret konfiguriert: {value}',
  'adm.jira.secretHint': 'Verwenden Sie dasselbe Secret beim Erstellen des Jira-Webhooks.',
  'adm.jira.secretOptional': 'Optional, mindestens 16 Zeichen',
  'adm.jira.siteUrl': 'Jira-Site-URL',
  'adm.jira.siteUrlHint': 'Geben Sie keine Zugangsdaten in der URL an.',
  'adm.jira.syncFromJira': 'Jira-Status zurück ins Ticket',
  'adm.jira.syncSnapshot': 'Snapshot des verknüpften Issues',
  'adm.jira.syncToJira': 'Ticketstatus nach Jira',
  'adm.jira.testConnection': 'Verbindung testen',
  'adm.jira.testFailed': 'Verbindungstest fehlgeschlagen',
  'adm.jira.title': 'Jira-Integration',
  'adm.jira.tokenHintEdit': 'Leer lassen, um das aktuelle Token beizubehalten.',
  'adm.jira.tokenHintNew': 'Wird verschlüsselt gespeichert und nicht erneut angezeigt.',
  'adm.jira.tokenMissing': 'API-Token fehlt',
  'adm.jira.tokenStored': 'API-Token gespeichert',
  'adm.jira.unchanged': '(unverändert, wenn leer)',
  'adm.jira.verified': 'Jira-Verbindung überprüft',
  'adm.jira.webhookEndpoint': 'Jira-Webhook-Endpunkt',
  'adm.jira.webhookSecret': 'Webhook-Secret',
  'adm.jira.whatSyncs': 'Was synchronisiert wird',
  'adm.jira.yes': 'Ja',
  'adm.nameRequired': 'Name *',
  'adm.nextPage': 'Nächste Seite',
  'adm.notif.aud.all': 'Gemeinsam',
  'adm.notif.aud.customer': 'Kunde',
  'adm.notif.aud.internal': 'Intern',
  'adm.notif.audEmail': '{audience}-E-Mail',
  'adm.notif.body': 'Text',
  'adm.notif.description': 'Passen Sie jede Benachrichtigungszielgruppe an, ohne Kunden in den internen Arbeitsbereich zu leiten.',
  'adm.notif.discardDesc': 'Ihre nicht gespeicherten Änderungen an dieser Benachrichtigungsvorlage gehen verloren, wenn Sie die Vorlage wechseln.',
  'adm.notif.discardLabel': 'Änderungen verwerfen',
  'adm.notif.discardTitle': 'Nicht gespeicherte Änderungen verwerfen?',
  'adm.notif.discarded': 'Nicht gespeicherte Änderungen verworfen.',
  'adm.notif.event.automation_notification': 'Automatisierungsbenachrichtigung',
  'adm.notif.event.group_member_added': 'Zur Gruppe hinzugefügt',
  'adm.notif.event.mention': 'Erwähnung',
  'adm.notif.event.pending_input': 'Ausstehende Eingabe',
  'adm.notif.event.sla_breach': 'SLA-Verletzung',
  'adm.notif.event.sla_escalation': 'SLA-Eskalation',
  'adm.notif.event.sla_warning': 'SLA-Warnung',
  'adm.notif.event.ticket_assigned': 'Ticket zugewiesen',
  'adm.notif.event.ticket_created': 'Ticket erstellt',
  'adm.notif.event.ticket_first_response': 'Erste Antwort',
  'adm.notif.event.ticket_group_assigned': 'Ticket einer Gruppe zugewiesen',
  'adm.notif.event.ticket_note': 'Private Notiz',
  'adm.notif.event.ticket_public_note': 'Öffentliche Notiz',
  'adm.notif.event.ticket_reply': 'Ticket-Antwort',
  'adm.notif.event.ticket_resolved': 'Ticket gelöst',
  'adm.notif.events': 'Ereignisse',
  'adm.notif.eventsHelp': 'Wählen Sie ein Ereignis und eine Empfängerzielgruppe.',
  'adm.notif.insertVar': '{variable} einfügen',
  'adm.notif.linkNoteAgent': 'Die zielgruppenabhängige Link-Variable {variable} öffnet für diese E-Mail den Agenten-Arbeitsbereich.',
  'adm.notif.linkNoteCustomer': 'Die zielgruppenabhängige Link-Variable {variable} öffnet für diese E-Mail das Kundenportal.',
  'adm.notif.off': 'aus',
  'adm.notif.preview': 'Vorschau',
  'adm.notif.previewNotice': 'Vorschau mit Beispieldaten erstellt.',
  'adm.notif.rendering': 'Wird gerendert…',
  'adm.notif.route.all': 'Verwendet den empfängerabhängigen Ticketlink für die Zustellungszielgruppe.',
  'adm.notif.route.customer': 'Die Hauptaktion öffnet das Ticket im Kundenportal.',
  'adm.notif.route.internal': 'Die Hauptaktion öffnet das Ticket im Agenten-Arbeitsbereich.',
  'adm.notif.sampleOnlyAgent': 'Nur Beispieldaten – die Hauptaktion führt zur Route des Agenten-Arbeitsbereichs.',
  'adm.notif.sampleOnlyCustomer': 'Nur Beispieldaten – die Hauptaktion führt zur Route des Kundenportals.',
  'adm.notif.saveChanges': 'Änderungen speichern',
  'adm.notif.saved': 'Vorlage gespeichert.',
  'adm.notif.savedBtn': 'Gespeichert',
  'adm.notif.selectEvent': 'Wählen Sie ein Ereignis, um seine Vorlage zu bearbeiten',
  'adm.notif.selectEventDesc': 'Wählen Sie links ein Benachrichtigungsereignis, um Betreff und Text zu ändern.',
  'adm.notif.sendTest': 'Test-E-Mail senden',
  'adm.notif.sending': 'Wird gesendet…',
  'adm.notif.subject': 'Betreff',
  'adm.notif.testQueued': 'Test-E-Mail an {email} in die Warteschlange gestellt.',
  'adm.notif.title': 'Benachrichtigungsvorlagen',
  'adm.notif.urlVarTitle': 'Zielgruppenabhängige Link-Variable',
  'adm.notif.useTemplate': 'Diese Vorlage für diese Zielgruppe verwenden',
  'adm.notif.useTemplateHelp': 'Wenn deaktiviert, wird die sichere Standardbenachrichtigung verwendet.',
  'adm.notif.variables': 'Variablen',
  'adm.notif.variablesHelp': 'Klicken, um an den Nachrichtentext anzuhängen',
  'adm.pagination': 'Seitennavigation',
  'adm.perm.cap.admin.label': 'Auf die Administrationskonsole zugreifen',
  'adm.perm.cap.assign.label': 'Ein Ticket zuweisen',
  'adm.perm.cap.close.label': 'Ein Ticket schließen',
  'adm.perm.cap.conversation_delete.label': 'Eine gesendete Antwort oder Notiz löschen',
  'adm.perm.cap.conversation_edit.label': 'Eine gesendete Antwort oder Notiz bearbeiten',
  'adm.perm.cap.create.label': 'Ein Ticket erstellen',
  'adm.perm.cap.delete.label': 'Ein Ticket löschen',
  'adm.perm.cap.edit.label': 'Ticket-Eigenschaften bearbeiten',
  'adm.perm.cap.export.label': 'Tickets exportieren',
  'adm.perm.cap.field_admin.label': 'Ticketfelder',
  'adm.perm.cap.form_admin.label': 'Ticketformulare',
  'adm.perm.cap.forward.label': 'Ein Ticket weiterleiten',
  'adm.perm.cap.jira_link.label': 'Jira-Issues verknüpfen und verwalten',
  'adm.perm.cap.kb.label': 'Auf die Wissensdatenbank zugreifen',
  'adm.perm.cap.manage_agents.label': 'Agenten',
  'adm.perm.cap.manage_api_keys.label': 'API-Schlüssel',
  'adm.perm.cap.manage_automations.label': 'Automatisierungen',
  'adm.perm.cap.manage_canned_responses.label': 'Textbausteine',
  'adm.perm.cap.manage_email_config.label': 'E-Mail',
  'adm.perm.cap.manage_groups.label': 'Gruppen',
  'adm.perm.cap.manage_jira.label': 'Jira-Integration',
  'adm.perm.cap.manage_kb.label': 'Wissensdatenbank',
  'adm.perm.cap.manage_notification_templates.label': 'Benachrichtigungsvorlagen',
  'adm.perm.cap.manage_roles.label': 'Rollen',
  'adm.perm.cap.manage_tags.label': 'Tags',
  'adm.perm.cap.note.label': 'Private Notizen hinzufügen oder bearbeiten',
  'adm.perm.cap.reassign.label': 'Ein Ticket neu zuweisen, das bereits jemand anderem gehört',
  'adm.perm.cap.reopen.label': 'Ein gelöstes oder geschlossenes Ticket wieder öffnen',
  'adm.perm.cap.reply.label': 'Dem Kunden öffentlich antworten',
  'adm.perm.cap.report_access.label': 'Berichte und Dashboards ansehen',
  'adm.perm.cap.reports.label': 'Auf das Berichtsmodul zugreifen',
  'adm.perm.cap.resolve.label': 'Ein Ticket lösen',
  'adm.perm.cap.settings_admin.label': 'Den Bereich „Einstellungen“ öffnen (erforderlich, um den Navigationspunkt „Einstellungen“ und seine Übersichtsseite zu sehen; der Zugriff auf jede der folgenden Seiten wird weiterhin einzeln gesteuert)',
  'adm.perm.cap.sla_admin.label': 'SLA-Richtlinien & Geschäftszeiten',
  'adm.perm.cap.sla_edit.desc': 'Unabhängig von der folgenden Berechtigung „Einstellungen > SLA-Richtlinien“ – diese umfasst nur das Bearbeiten von Fälligkeitsdaten an einem einzelnen Ticket.',
  'adm.perm.cap.sla_edit.label': 'SLA-Fälligkeitsdaten eines Tickets manuell überschreiben',
  'adm.perm.cap.tag.label': 'Ticket-Tags verwalten',
  'adm.perm.cap.thread_start.label': 'Einen privaten Thread zu einem Konversationseintrag starten',
  'adm.perm.cap.tickets.label': 'Auf den Ticket-Arbeitsbereich zugreifen',
  'adm.perm.cap.view.label': 'Tickets im Zuständigkeitsbereich ansehen',
  'adm.perm.cat.administration.desc': 'Zugriff auf die Administrationskonsole und ihre Konfigurationsbildschirme.',
  'adm.perm.cat.administration.label': 'Administration',
  'adm.perm.cat.knowledge.desc': 'Wissensinhalte lesen und nutzen, während ein Ticket bearbeitet wird.',
  'adm.perm.cat.knowledge.label': 'Wissensdatenbank',
  'adm.perm.cat.reporting.desc': 'Operatives Reporting und Dashboards.',
  'adm.perm.cat.reporting.label': 'Berichte',
  'adm.perm.cat.settings-pages.desc': 'Gewähren Sie den Zugriff auf jeden Einstellungsbildschirm einzeln. Nichts ist sichtbar, solange es hier nicht ausdrücklich aktiviert ist.',
  'adm.perm.cat.settings-pages.label': 'Einstellungsseiten',
  'adm.perm.cat.tickets.desc': 'Was ein Agent im Ticket-Arbeitsbereich tun kann.',
  'adm.perm.cat.tickets.label': 'Tickets',
  'adm.previousPage': 'Vorherige Seite',
  'adm.refresh': 'Aktualisieren',
  'adm.roleType.administrator': 'Administrator',
  'adm.roleType.agent': 'Agent',
  'adm.roleType.collaborator': 'Mitarbeiter',
  'adm.roleType.customer': 'Kunde',
  'adm.roleType.super_admin': 'Super-Admin',
  'adm.roleType.supervisor': 'Supervisor',
  'adm.roles.activeHelp': 'Aktiv – inaktive Rollen können Agenten nicht zugewiesen werden',
  'adm.roles.agentCan': 'Agent darf',
  'adm.roles.agentType': 'Agententyp',
  'adm.roles.agentsAssignedNote': 'Agenten wird diese Rolle im Bildschirm „Agenten“ zugewiesen.',
  'adm.roles.agentsCount': '{count} Agenten',
  'adm.roles.agentsLabel': 'Agenten',
  'adm.roles.agentsManage': '{count} Agenten – Verwalten',
  'adm.roles.builtIn': '(Integriert)',
  'adm.roles.builtInNote': 'Dies ist eine integrierte Rolle. Sie kann umbenannt und deaktiviert, aber nicht gelöscht werden.',
  'adm.roles.builtInTitle': 'Integrierte Rolle: bearbeitbar und deaktivierbar, aber nicht löschbar',
  'adm.roles.categoriesAria': 'Berechtigungskategorien',
  'adm.roles.confirmDesc': 'Agenten, denen diese Rolle zugewiesen ist, benötigen eine andere Rolle, bevor sie entfernt werden kann.',
  'adm.roles.confirmLabel': 'Rolle löschen',
  'adm.roles.createFirst': 'Erstellen Sie Ihre erste Rolle',
  'adm.roles.createFirstDesc': 'Mit „Neue Rolle“ legen Sie fest, welche Fähigkeiten Agenten erhalten sollen.',
  'adm.roles.editRole': 'Rolle bearbeiten',
  'adm.roles.granted': '{count} gewährt',
  'adm.roles.heading': 'Agentenrollen',
  'adm.roles.inactive': 'Inaktiv',
  'adm.roles.newRole': 'Neue Rolle',
  'adm.roles.noAgent': 'Kein Agent',
  'adm.roles.notEnforced': '(noch nicht durchgesetzt)',
  'adm.roles.notEnforcedTitle': 'In der Rolle gespeichert, aber zur Laufzeit noch nirgends geprüft',
  'adm.roles.permissions': 'Berechtigungen',
  'adm.roles.saved': 'Rolle gespeichert.',
  'adm.roles.scopeBody': 'Fähigkeiten werden mit dem Zeilenbereich (alle / Gruppe / zugewiesen / eigene) kombiniert, sodass ein Agent nur Tickets bearbeitet, die er ohnehin sehen kann.',
  'adm.roles.scopeTitle': 'Der Zuständigkeitsbereich gilt weiterhin',
  'adm.roles.scrollTo': 'Springen zu',
  'adm.roles.status': 'Status',
  'adm.roles.subtitle': 'Legen Sie detaillierte Zugriffsebenen und Rechte für Agenten fest und schränken Sie sie ein.',
  'adm.roles.title': 'Rollen',
  'adm.roles.typeLocked': 'Der Agententyp kann nach dem Speichern einer Rolle nicht mehr geändert werden.',
  'adm.roles.understandingBody1': 'Rollen bestimmen, was ein Agent tun kann. Erstellen Sie eine Rolle, aktivieren Sie die gewünschten Fähigkeiten und weisen Sie sie dann im Bildschirm „Agenten“ Agenten zu.',
  'adm.roles.understandingBody2': 'Integrierte Rollen können umbenannt und deaktiviert, aber nie gelöscht werden. Eine Rolle, der noch Agenten zugewiesen sind, kann ebenfalls nicht gelöscht werden. Verschieben Sie diese Agenten daher zuerst.',
  'adm.roles.understandingTitle': 'Rollen verstehen',
  'adm.saveChanges': 'Änderungen speichern',
  'adm.settings.add': '{name} hinzufügen',
  'adm.settings.back': 'Zurück zu den Einstellungen',
  'adm.settings.cannedDesc': 'Kontoweite Antworten, die Ihnen bei der Bearbeitung eines Tickets zur Verfügung stehen.',
  'adm.settings.cannedEmpty': 'Noch keine Textbausteine',
  'adm.settings.cannedEmptyDesc': 'Bitten Sie einen Administrator, gemeinsame Antworten hinzuzufügen, die Ihr Team in Tickets wiederverwenden kann.',
  'adm.settings.cannedTitle': 'Textbausteine',
  'adm.settings.col.autoAssign': 'Automatisch zuweisen',
  'adm.settings.col.color': 'Farbe',
  'adm.settings.col.content': 'Inhalt',
  'adm.settings.col.createdAt': 'Erstellt am',
  'adm.settings.col.description': 'Beschreibung',
  'adm.settings.col.email': 'E-Mail',
  'adm.settings.col.expiresAt': 'Läuft ab am',
  'adm.settings.col.fieldType': 'Feldtyp',
  'adm.settings.col.firstName': 'Vorname',
  'adm.settings.col.folderId': 'Ordner-ID',
  'adm.settings.col.hitCount': 'Trefferanzahl',
  'adm.settings.col.holidays': 'Feiertage',
  'adm.settings.col.host': 'Host',
  'adm.settings.col.hours': 'Zeiten',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Ist aktiv',
  'adm.settings.col.isBuiltIn': 'Ist integriert',
  'adm.settings.col.isDefault': 'Ist Standard',
  'adm.settings.col.isRequired': 'Ist erforderlich',
  'adm.settings.col.isShared': 'Ist geteilt',
  'adm.settings.col.isSystem': 'Ist System',
  'adm.settings.col.key': 'Schlüssel',
  'adm.settings.col.label': 'Bezeichnung',
  'adm.settings.col.language': 'Sprache',
  'adm.settings.col.lastName': 'Nachname',
  'adm.settings.col.lastUsedAt': 'Zuletzt verwendet am',
  'adm.settings.col.name': 'Name',
  'adm.settings.col.options': 'Optionen',
  'adm.settings.col.phone': 'Telefon',
  'adm.settings.col.port': 'Port',
  'adm.settings.col.position': 'Position',
  'adm.settings.col.prefix': 'Präfix',
  'adm.settings.col.priority': 'Priorität',
  'adm.settings.col.required': 'Erforderlich',
  'adm.settings.col.role': 'Rolle',
  'adm.settings.col.roleId': 'Rollen-ID',
  'adm.settings.col.scopes': 'Bereiche',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Status',
  'adm.settings.col.stopProcessing': 'Verarbeitung stoppen',
  'adm.settings.col.timezone': 'Zeitzone',
  'adm.settings.col.title': 'Titel',
  'adm.settings.col.trigger': 'Auslöser',
  'adm.settings.col.type': 'Typ',
  'adm.settings.col.updatedAt': 'Aktualisiert am',
  'adm.settings.col.usageCount': 'Nutzungsanzahl',
  'adm.settings.col.username': 'Benutzername',
  'adm.settings.confirmDesc': 'Dies kann nicht rückgängig gemacht werden.',
  'adm.settings.confirmTitle': '{name} löschen?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Erstellen',
  'adm.settings.empty': 'Noch keine Einträge für {title}',
  'adm.settings.emptyAdd': 'Verwenden Sie das Formular oben, um Ihr erstes Element ({name}) hinzuzufügen.',
  'adm.settings.emptyOther': 'Einträge erscheinen hier, sobald sie konfiguriert sind.',
  'adm.settings.homeDesc': 'Konfigurieren Sie Benutzer, Ticket-Workflows, Servicelevel und Integrationen.',
  'adm.settings.manage': '{title} verwalten.',
  'adm.settings.noPages': 'Keine Einstellungsseiten verfügbar',
  'adm.settings.noPagesDesc': 'Bitten Sie einen Super-Admin, Ihnen Zugriff auf die benötigten Einstellungsseiten zu gewähren.',
  'adm.settings.notFound': 'Einstellungsseite nicht gefunden',
  'adm.settings.notFoundDesc': 'Wählen Sie einen Einstellungsbereich, um fortzufahren.',
  'adm.settings.res.agents.field.email': 'E-Mail',
  'adm.settings.res.agents.field.firstName': 'Vorname',
  'adm.settings.res.agents.field.lastName': 'Nachname',
  'adm.settings.res.agents.field.password': 'Temporäres Passwort',
  'adm.settings.res.agents.field.roleId': 'Rollen-ID',
  'adm.settings.res.agents.one': 'Agent',
  'adm.settings.res.agents.title': 'Agenten',
  'adm.settings.res.api-keys.field.name': 'Schlüsselname',
  'adm.settings.res.api-keys.one': 'API-Schlüssel',
  'adm.settings.res.api-keys.title': 'API-Schlüssel',
  'adm.settings.res.automations.field.description': 'Beschreibung',
  'adm.settings.res.automations.field.name': 'Name',
  'adm.settings.res.automations.one': 'Automatisierung',
  'adm.settings.res.automations.title': 'Automatisierungen',
  'adm.settings.res.business-hours.field.name': 'Name',
  'adm.settings.res.business-hours.field.timezone': 'Zeitzone',
  'adm.settings.res.business-hours.one': 'Geschäftszeiteneintrag',
  'adm.settings.res.business-hours.title': 'Geschäftszeiten',
  'adm.settings.res.canned-responses.field.content': 'Inhalt des Textbausteins',
  'adm.settings.res.canned-responses.field.title': 'Titel',
  'adm.settings.res.canned-responses.one': 'Textbaustein',
  'adm.settings.res.canned-responses.title': 'Textbausteine',
  'adm.settings.res.email.field.host': 'SMTP-Host',
  'adm.settings.res.email.field.name': 'Name',
  'adm.settings.res.email.field.port': 'SMTP-Port',
  'adm.settings.res.email.field.username': 'Benutzername',
  'adm.settings.res.email.one': 'E-Mail-Konfiguration',
  'adm.settings.res.email.title': 'E-Mail-Konfiguration',
  'adm.settings.res.fields.one': 'Ticketfeld',
  'adm.settings.res.fields.title': 'Ticketfelder',
  'adm.settings.res.forms.field.label': 'Anzeigebezeichnung',
  'adm.settings.res.forms.field.name': 'Feldname',
  'adm.settings.res.forms.field.type': 'Feldtyp',
  'adm.settings.res.forms.one': 'Formular oder benutzerdefiniertes Feld',
  'adm.settings.res.forms.title': 'Formulare und benutzerdefinierte Felder',
  'adm.settings.res.groups.field.description': 'Beschreibung',
  'adm.settings.res.groups.field.name': 'Name',
  'adm.settings.res.groups.one': 'Gruppe',
  'adm.settings.res.groups.title': 'Gruppen',
  'adm.settings.res.jira.one': 'Jira-Integration',
  'adm.settings.res.jira.title': 'Jira-Integration',
  'adm.settings.res.kb.field.content': 'Artikelinhalt',
  'adm.settings.res.kb.field.folderId': 'Ordner-ID',
  'adm.settings.res.kb.field.title': 'Artikeltitel',
  'adm.settings.res.kb.one': 'Wissensdatenbank-Artikel',
  'adm.settings.res.kb.title': 'Verwaltung der Wissensdatenbank',
  'adm.settings.res.notification-templates.one': 'Benachrichtigungsvorlage',
  'adm.settings.res.notification-templates.title': 'Benachrichtigungsvorlagen',
  'adm.settings.res.roles.field.description': 'Beschreibung',
  'adm.settings.res.roles.field.name': 'Name',
  'adm.settings.res.roles.field.type': 'Rollentyp',
  'adm.settings.res.roles.one': 'Rolle',
  'adm.settings.res.roles.title': 'Rollen',
  'adm.settings.res.sla.field.description': 'Beschreibung',
  'adm.settings.res.sla.field.name': 'Name',
  'adm.settings.res.sla.one': 'SLA-Richtlinie',
  'adm.settings.res.sla.title': 'SLA-Richtlinien',
  'adm.settings.res.tags.field.name': 'Name',
  'adm.settings.res.tags.one': 'Tag',
  'adm.settings.res.tags.title': 'Tags',
  'adm.settings.title': 'Einstellungen',
  'adm.status': 'Status',

  'sla.edit': 'Bearbeiten',
  'sla.active': 'Aktiv',
  'sla.inactive': 'Inaktiv',
  'sla.default': 'Standard',
  'sla.yes': 'Ja',
  'sla.no': 'Nein',
  'sla.description': 'Beschreibung',
  'sla.status': 'Status',
  'sla.notConfigured': 'Nicht konfiguriert',
  'sla.minutesValue': '{value} Minuten',
  'sla.invalidServerValue': 'Ungültiger Serverwert',
  'sla.statusSemantics.title': 'Semantik der Ticketstatus',
  'sla.statusSemantics.description': 'Jeder aktive Status hat einen expliziten SLA-Vertrag. Ein pausierender Status und ein Status, der das SLA beendet, schließen sich gegenseitig aus.',
  'sla.statusSemantics.conflict': 'Ein Status kann das SLA nicht gleichzeitig pausieren und beenden.',
  'sla.statusSemantics.emptyTitle': 'Keine Statusdefinitionen',
  'sla.statusSemantics.emptyDescription': 'Statusdefinitionen erscheinen hier, sobald sie für dieses Konto konfiguriert sind.',
  'sla.statusSemantics.colPauses': 'Pausiert SLA',
  'sla.statusSemantics.colStops': 'Stoppt SLA',
  'sla.statusSemantics.pausesAria': '{label} pausiert das SLA',
  'sla.statusSemantics.stopsAria': '{label} stoppt das SLA',
  'sla.preview.title': 'Schreibgeschützte Ticketvorschau',
  'sla.preview.description': 'Führt denselben kontobezogenen Evaluator aus, der von aktiven SLA-Zyklen verwendet wird. Diese Vorschau schreibt nie eine Richtlinie oder ein Ticket.',
  'sla.preview.priority': 'Priorität',
  'sla.preview.group': 'Gruppe',
  'sla.preview.anyGroup': 'Beliebige Gruppe',
  'sla.preview.company': 'Unternehmen',
  'sla.preview.anyCompany': 'Beliebiges Unternehmen',
  'sla.preview.source': 'Quelle',
  'sla.preview.anySource': 'Beliebige Quelle',
  'sla.preview.ticketType': 'Tickettyp',
  'sla.preview.anyTicketType': 'Beliebiger Tickettyp',
  'sla.preview.representativeStart': 'Repräsentativer Start',
  'sla.preview.calculating': 'Wird berechnet…',
  'sla.preview.run': 'Vorschau ausführen',
  'sla.preview.configAttention': 'Die Konfiguration erfordert Aufmerksamkeit',
  'sla.preview.selectedPolicy': 'Ausgewählte Richtlinie',
  'sla.preview.noPolicy': 'Keine Richtlinie',
  'sla.preview.evaluationOrder': 'Auswertungsreihenfolge',
  'sla.preview.firstMatching': 'Erste passende Richtlinie',
  'sla.preview.calculationMode': 'Berechnungsmodus',
  'sla.preview.modeBusinessHours': 'Geschäftszeiten',
  'sla.preview.modeBusinessHoursNamed': 'Geschäftszeiten · {name}',
  'sla.preview.mode247': 'Verstrichene Zeit rund um die Uhr (24/7)',
  'sla.preview.modeNone': 'Nicht berechnet',
  'sla.preview.thresholds': 'Unabhängige Schwellenwerte',
  'sla.preview.colMetric': 'Metrik',
  'sla.preview.colTarget': 'Ziel',
  'sla.preview.colWarning': 'Warnung',
  'sla.preview.colDue': 'Fällig / Verletzung',
  'sla.preview.colEscalation': 'Eskalation',
  'sla.preview.colState': 'Zustand',
  'sla.preview.metricFirstResponse': 'Erste Antwort',
  'sla.preview.metricResolution': 'Lösung',
  'sla.preview.trace': 'Ablaufprotokoll der Richtlinienauswertung',
  'sla.preview.selected': 'Ausgewählt',
  'sla.preview.matchedAfterSelection': 'Nach der Auswahl zutreffend',
  'sla.preview.skipped': 'Übersprungen',
  'sla.preview.showTrace': 'Berechnungsprotokoll anzeigen',
  'sla.state.not_configured': 'nicht konfiguriert',
  'sla.state.running': 'läuft',
  'sla.state.paused': 'pausiert',
  'sla.state.warning': 'Warnung',
  'sla.state.breached': 'verletzt',
  'sla.state.met': 'erfüllt',
  'sla.state.escalated': 'eskaliert',
  'sla.state.pending': 'ausstehend',
  'sla.state.stopped': 'gestoppt',
  'sla.state.on_track': 'im Plan',
  'sla.state.at_risk': 'gefährdet',
  'sla.list.subtitle': 'Legen Sie Ziele für die erste Antwort und die Lösung je Priorität fest. Richtlinien werden von oben nach unten ausgewertet – die erste, deren Bedingungen auf ein Ticket zutreffen, gewinnt.',
  'sla.list.newPolicy': 'Neue Richtlinie',
  'sla.list.emptyTitle': 'Erstellen Sie Ihre erste SLA-Richtlinie',
  'sla.list.emptyDescription': 'Mit „Neue Richtlinie“ legen Sie Ziele für die erste Antwort und die Lösung je Priorität fest.',
  'sla.list.moveUp': 'Nach oben',
  'sla.list.moveDown': 'Nach unten',
  'sla.list.frShort': 'EA: {value}',
  'sla.list.resolveShort': 'Lösung: {value}',
  'sla.list.escalateShort': 'Eskalation: +{value}',
  'sla.list.deactivate': 'Deaktivieren',
  'sla.list.activate': 'Aktivieren',
  'sla.list.setDefault': 'Als Standard festlegen',
  'sla.list.duplicate': 'Duplizieren',
  'sla.list.deleteTitle': '„{name}“ löschen?',
  'sla.list.deleteDescription': 'Tickets, die dieser Richtlinie zugeordnet waren, verwenden die nächste verfügbare SLA-Richtlinie.',
  'sla.list.deleteConfirm': 'Richtlinie löschen',
  'sla.conditions.groups': '{count} Gruppe(n)',
  'sla.conditions.companies': '{count} Unternehmen',
  'sla.conditions.sources': 'Quellen: {list}',
  'sla.conditions.ticketTypes': '{count} Tickettyp(en)',
  'sla.conditions.anyOf': 'beliebige von',
  'sla.conditions.allOf': 'alle von',
  'sla.conditions.summary': 'Bedingungen ({mode}): {parts}',
  'sla.edit.newTitle': 'Neue SLA-Richtlinie',
  'sla.edit.editTitle': 'SLA-Richtlinie bearbeiten',
  'sla.edit.saved': 'SLA-Richtlinie gespeichert.',
  'sla.edit.name': 'Name',
  'sla.edit.appliesToPriority': 'Gilt für Priorität',
  'sla.edit.evaluationOrder': 'Auswertungsreihenfolge',
  'sla.edit.evaluationOrderHint': 'Niedrigere Positionen werden für dieses Konto zuerst ausgewertet.',
  'sla.edit.defaultPolicy': 'Standardrichtlinie',
  'sla.edit.useAsDefault': 'Als Standard verwenden, wenn keine andere Richtlinie zutrifft',
  'sla.edit.targets': 'SLA-Ziele',
  'sla.edit.firstResponse': 'Erste Antwort',
  'sla.edit.resolution': 'Lösung',
  'sla.edit.autoAt75': 'Automatisch bei 75 %',
  'sla.edit.enabledAfter': 'Aktiviert nach {value}',
  'sla.edit.clearEscalation': 'Eskalationsziel ausdrücklich entfernen',
  'sla.edit.clearEscalationHint': 'Sendet null; bleibt dies deaktiviert, wird das Feld weggelassen und der gespeicherte Wert beibehalten.',
  'sla.edit.firstResponseMinutes': 'Erste Antwort (Minuten)',
  'sla.edit.resolutionMinutes': 'Lösung (Minuten)',
  'sla.edit.escalateAfter': 'Eskalieren nach (Minuten nach Lösungsfälligkeit)',
  'sla.edit.notSet': 'Nicht festgelegt',
  'sla.edit.remindersNote': 'Erinnerungen werden automatisch bei 75 % der Fenster für erste Antwort und Lösung ausgelöst. Die Eskalation benachrichtigt den Eskalations-Agenten der Ticketgruppe (in der Gruppe festgelegt), sobald das Lösungsziel um die konfigurierte Anzahl an Minuten überschritten wurde.',
  'sla.edit.conditions': 'Bedingungen',
  'sla.edit.conditionsHint': 'Lassen Sie eine Gruppe deaktiviert, um alle Werte zu berücksichtigen',
  'sla.edit.matchMode': 'Abgleichsmodus:',
  'sla.edit.matchAll': 'ALLE Bedingungen müssen zutreffen',
  'sla.edit.matchAny': 'EINE beliebige Bedingung muss zutreffen',
  'sla.edit.groups': 'Gruppen',
  'sla.edit.companies': 'Unternehmen',
  'sla.edit.sources': 'Quellen',
  'sla.edit.ticketTypes': 'Tickettypen',
  'sla.bh.subtitle': 'Definieren Sie den Wochenplan und den Feiertagskalender, mit denen SLA-Richtlinien Fälligkeitsdaten berechnen.',
  'sla.bh.newCalendar': 'Neuer Kalender',
  'sla.bh.emptyTitle': 'Erstellen Sie Ihren ersten Geschäftszeitenkalender',
  'sla.bh.emptyDescription': 'Mit „Neuer Kalender“ definieren Sie den Wochenplan, nach dem SLA-Richtlinien zählen.',
  'sla.bh.accountDefault': 'Kontostandard',
  'sla.bh.closedEveryDay': 'An jedem Tag geschlossen',
  'sla.bh.openEveryDay': 'An jedem Tag geöffnet',
  'sla.bh.openDaysOne': '1 Tag/Woche geöffnet',
  'sla.bh.openDaysMany': '{count} Tage/Woche geöffnet',
  'sla.bh.holidayOne': '1 Feiertag',
  'sla.bh.holidayMany': '{count} Feiertage',
  'sla.bh.deleteTitle': '„{name}“ löschen?',
  'sla.bh.deleteDescription': 'SLA-Richtlinien und Gruppen, die diesen Plan verwenden, greifen auf den Kontostandard zurück.',
  'sla.bh.deleteConfirm': 'Plan löschen',
  'sla.bh.newTitle': 'Neuer Geschäftszeitenkalender',
  'sla.bh.editTitle': 'Geschäftszeiten bearbeiten',
  'sla.bh.saved': 'Geschäftszeiten gespeichert.',
  'sla.bh.timezone': 'Zeitzone',
  'sla.bh.defaultCalendar': 'Standardkalender',
  'sla.bh.useAsDefault': 'Für SLA-Richtlinien und Gruppen verwenden, die keinen eigenen Kalender angeben',
  'sla.bh.weeklySchedule': 'Wochenplan',
  'sla.bh.colDay': 'Tag',
  'sla.bh.colOpen': 'Geöffnet',
  'sla.bh.colStart': 'Beginn',
  'sla.bh.colEnd': 'Ende',
  'sla.bh.dayOpenAria': '{day} geöffnet',
  'sla.bh.dayStartAria': 'Beginn am {day}',
  'sla.bh.dayEndAria': 'Ende am {day}',
  'sla.bh.holidayCalendar': 'Feiertagskalender',
  'sla.bh.saveFirst': 'Speichern Sie zuerst diesen Kalender und fügen Sie dann Feiertage hinzu.',
  'sla.bh.holidayName': 'Name des Feiertags',
  'sla.bh.date': 'Datum',
  'sla.bh.addHoliday': 'Feiertag hinzufügen',
  'sla.bh.noHolidays': 'Noch keine Feiertage',
  'sla.bh.noHolidaysHint': 'Fügen Sie oben einen Feiertag mit Datum hinzu, um ihn von SLA-Berechnungen auszuschließen.',
  'sla.bh.remove': 'Entfernen',
  'sla.day.monday': 'Montag',
  'sla.day.tuesday': 'Dienstag',
  'sla.day.wednesday': 'Mittwoch',
  'sla.day.thursday': 'Donnerstag',
  'sla.day.friday': 'Freitag',
  'sla.day.saturday': 'Samstag',
  'sla.day.sunday': 'Sonntag',

  'set.ftype.single_line_text': 'Einzeiliger Text',
  'set.ftype.multi_line_text': 'Mehrzeiliger Text',
  'set.ftype.dropdown': 'Dropdown',
  'set.ftype.checkbox': 'Kontrollkästchen',
  'set.ftype.radio': 'Optionsfeld',
  'set.ftype.multiselect': 'Mehrfachauswahl',
  'set.ftype.lookup': 'Lookup-Beziehung',
  'set.ftype.dependent': 'Abhängiges Feld',
  'set.ftype.date': 'Datum',
  'set.ftype.number': 'Zahl',
  'set.ftype.decimal': 'Dezimalzahl',
  'set.ftype.desc.lookup': 'Einen Datensatz aus einer Systemquelle auswählen.',
  'set.ftype.desc.single_line_text': 'Kurzer Textwert.',
  'set.ftype.desc.multi_line_text': 'Langer Textwert.',
  'set.ftype.desc.checkbox': 'Wahr-oder-falsch-Wert.',
  'set.ftype.desc.dropdown': 'Eine normalisierte Option auswählen.',
  'set.ftype.desc.dependent': 'Optionen hängen von einem übergeordneten Feld ab.',
  'set.ftype.desc.date': 'Kalenderdatum.',
  'set.ftype.desc.number': 'Ganzzahlwert.',
  'set.ftype.desc.decimal': 'Dezimalzahlwert.',
  'set.src.STATIC': 'Statische Optionen',
  'set.src.AGENTS': 'Agenten',
  'set.src.USERS': 'Benutzer / Kunden',
  'set.src.GROUPS': 'Gruppen',
  'set.src.ROLE': 'Rollen',
  'set.src.COUNTRIES': 'Länder',
  'set.src.CUSTOM': 'Benutzerdefinierte Dropdown-Liste',
  'set.settings': 'Einstellungen',
  'set.ticketFields': 'Ticketfelder',
  'set.ticketForms': 'Ticketformulare',
  'set.requestFailed': 'Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'set.refresh': 'Aktualisieren',
  'set.saving': 'Wird gespeichert…',
  'set.saveChanges': 'Änderungen speichern',
  'set.default': 'Standard',
  'set.published': 'Veröffentlicht',
  'set.draft': 'Entwurf',
  'set.publish': 'Veröffentlichen',
  'set.unpublish': 'Veröffentlichung zurückziehen',
  'set.deleteForm': 'Formular löschen',
  'set.description': 'Beschreibung',
  'set.relationshipSource': 'Beziehungsquelle',
  'set.dependsOn': 'Abhängig von {field}',
  'set.deleteFormTitle': '„{name}“ löschen?',
  'set.deleteFormDescription': 'Dieses Ticketformular und seine Konfiguration werden dauerhaft gelöscht.',
  'set.formIdRequired': 'Eine Formular-ID ist erforderlich.',
  'set.formNotFound': 'Ticketformular nicht gefunden.',
  'set.tf.removeOption': '{label} entfernen',
  'set.tf.noOptions': 'Noch keine Optionen definiert.',
  'set.tf.addOptionPlaceholder': 'Option hinzufügen...',
  'set.tf.add': 'Hinzufügen',
  'set.tf.dependsOnField': 'Abhängig vom Feld',
  'set.tf.selectParent': '— Übergeordnetes Feld auswählen —',
  'set.tf.parentHelp': 'Das übergeordnete Dropdown-Feld, dessen ausgewählter Wert die verfügbaren Optionen dieses Felds bestimmt.',
  'set.tf.optionMappings': 'Optionszuordnungen',
  'set.tf.savingParen': '(wird gespeichert...)',
  'set.tf.mappingsError': 'Zuordnungen konnten nicht geladen werden',
  'set.tf.archivedParen': ' (archiviert)',
  'set.tf.mappedCount': '{count} zugeordnet',
  'set.tf.saveFirst': 'Speichern Sie zuerst das Feld, um Optionszuordnungen zu konfigurieren.',
  'set.tf.newField': 'Neues Feld: {type}',
  'set.tf.pageDescription': 'Verwalten Sie importierte Felddefinitionen, Sichtbarkeit, Pflichtregeln und die in Ticketformularen verwendete Reihenfolge.',
  'set.tf.addField': 'Feld hinzufügen',
  'set.tf.addFieldHelp': 'Ziehen Sie einen Typ in die Feldliste oder verwenden Sie „Hinzufügen“.',
  'set.tf.addType': '{type} hinzufügen',
  'set.tf.registry': 'Feldverzeichnis',
  'set.tf.savingOrder': 'Reihenfolge wird gespeichert…',
  'set.tf.searchAria': 'Ticketfelder durchsuchen',
  'set.tf.searchPlaceholder': 'Nach Name oder Schlüssel suchen...',
  'set.tf.filterAria': 'Nach Feldtyp filtern',
  'set.tf.allTypes': 'Alle Feldtypen',
  'set.tf.emptyFirstTitle': 'Fügen Sie Ihr erstes Ticketfeld hinzu',
  'set.tf.emptyFirstDesc': 'Ziehen Sie einen Feldtyp aus der Palette oder verwenden Sie „Hinzufügen“, um eines zu erstellen.',
  'set.tf.emptyFilterTitle': 'Keine Felder entsprechen diesen Filtern',
  'set.tf.emptyFilterDesc': 'Versuchen Sie einen anderen Suchbegriff oder erweitern Sie den Feldtypfilter.',
  'set.tf.archived': 'Archiviert',
  'set.tf.dependent': 'Abhängig',
  'set.tf.customerVisible': 'Für Kunden sichtbar',
  'set.tf.internal': 'Intern',
  'set.tf.configuration': 'Feldkonfiguration',
  'set.tf.selectTitle': 'Feld zur Konfiguration auswählen',
  'set.tf.selectDesc': 'Wählen Sie ein Feld aus dem Verzeichnis, um Bezeichnungen, Regeln und Sichtbarkeit zu bearbeiten.',
  'set.tf.externalId': 'Externe ID: {value}',
  'set.tf.sourceRenderer': 'Quelle: {source} · Renderer: {renderer}',
  'set.tf.optionSource': 'Optionsquelle: {value}',
  'set.tf.dependsOnKey': 'Abhängig von: {value}',
  'set.tf.internalLabel': 'Interne Bezeichnung',
  'set.tf.customerLabel': 'Kundenbezeichnung',
  'set.tf.relationshipHelp': 'Legt fest, woher Lookup-Werte zur Laufzeit abgerufen werden.',
  'set.tf.validationVisibility': 'Validierung und Sichtbarkeit',
  'set.tf.requiredAgents': 'Für Agenten erforderlich',
  'set.tf.requiredCustomers': 'Für Kunden erforderlich',
  'set.tf.requiredClosure': 'Für den Abschluss erforderlich',
  'set.tf.displayedCustomers': 'Kunden angezeigt',
  'set.tf.customersEdit': 'Kunden dürfen bearbeiten',
  'set.tf.customersFilter': 'Kunden dürfen filtern',
  'set.tf.active': 'Aktiv',
  'set.tf.dropdownOptions': 'Dropdown-Optionen ({count})',
  'set.tf.archiveTitle': '„{name}“ archivieren?',
  'set.tf.archiveDesc': 'Das Feld wird inaktiv und steht für neue Tickets nicht mehr zur Verfügung. Vorhandene Ticketdaten bleiben erhalten.',
  'set.tf.archiveField': 'Feld archivieren',
  'set.tf.alreadyArchived': 'Bereits archiviert',
  'set.tf.archivedNote': 'Archivierte Felder bleiben für historische Werte verfügbar.',
  'set.tfm.systemUser': 'System',
  'set.tfm.untitled': 'Formular ohne Titel',
  'set.tfm.pageDescription': 'Erstellen Sie wiederverwendbare Formulare und legen Sie fest, welche importierten Felder Agenten und Kunden nutzen können.',
  'set.tfm.newForm': 'Neues Formular',
  'set.tfm.creating': 'Wird erstellt…',
  'set.tfm.allForms': 'Alle Formulare',
  'set.tfm.configuredOne': '{count} konfiguriertes Formular',
  'set.tfm.configuredMany': '{count} konfigurierte Formulare',
  'set.tfm.filter': 'Filter',
  'set.tfm.searchAria': 'Ticketformulare durchsuchen',
  'set.tfm.searchPlaceholder': 'Formulare suchen…',
  'set.tfm.status': 'Status',
  'set.tfm.allStatuses': 'Alle Status',
  'set.tfm.emptyFilterTitle': 'Keine Formulare entsprechen diesen Filtern',
  'set.tfm.emptyFilterDesc': 'Versuchen Sie einen anderen Suchbegriff oder erweitern Sie den Statusfilter.',
  'set.tfm.emptyFirstTitle': 'Erstellen Sie Ihr erstes Ticketformular',
  'set.tfm.emptyFirstDesc': 'Erstellen Sie ein Formular, um mit der Konfiguration importierter Felder zu beginnen.',
  'set.tfm.createFirst': 'Ihr erstes Formular erstellen',
  'set.tfm.colName': 'Name',
  'set.tfm.colCreatedAt': 'Erstellt am',
  'set.tfm.colUpdatedBy': 'Zuletzt aktualisiert von',
  'set.tfm.colUpdatedAt': 'Zuletzt aktualisiert am',
  'set.tfm.colPortals': 'Zugehörige Portale',
  'set.tfm.colActions': 'Aktionen',
  'set.tfm.notConfigured': 'Nicht konfiguriert',
  'set.tfm.actionsFor': 'Aktionen für {name}',
  'set.tfm.editForm': 'Formular bearbeiten',
  'set.tb.section.default.title': 'Standardfelder',
  'set.tb.section.default.desc': 'Zentrale Support-Workflow-Felder, die aus dem Quellsystem importiert wurden.',
  'set.tb.section.custom.title': 'Benutzerdefinierte Felder',
  'set.tb.section.custom.desc': 'Zusätzliche Felder, die für Ihren Support-Prozess konfiguriert wurden.',
  'set.tb.section.nested.title': 'Verschachtelte Felder',
  'set.tb.section.nested.desc': 'Abhängige Felder, deren Optionen einem übergeordneten Feld folgen.',
  'set.tb.discardTitle': 'Nicht gespeicherte Änderungen verwerfen?',
  'set.tb.discardDesc': 'Ihre Änderungen an diesem Ticketformular wurden nicht gespeichert.',
  'set.tb.leave': 'Ohne Speichern verlassen',
  'set.tb.nameRequired': 'Der Formularname ist erforderlich.',
  'set.tb.saved': 'Formular gespeichert.',
  'set.tb.nowPublished': 'Formular veröffentlicht.',
  'set.tb.nowUnpublished': 'Veröffentlichung des Formulars zurückgezogen.',
  'set.tb.admin': 'Admin',
  'set.tb.builder': 'Builder',
  'set.tb.titleAria': 'Formulartitel',
  'set.tb.defaultLocked': 'Standard / gesperrt',
  'set.tb.previewPortal': 'Vorschau im Portal',
  'set.tb.configureTitle': 'Konfigurieren Sie die in diesem Formular enthaltenen Felder.',
  'set.tb.configureDesc': 'Änderungen werden in der Support-Desk-Datenbank gespeichert, wenn Sie „Änderungen speichern“ wählen. Pflichtfelder bleiben aktiviert.',
  'set.tb.formDetails': 'Formulardetails',
  'set.tb.formDetailsHelp': 'Verwenden Sie eine klare Beschreibung, damit Administratoren wissen, wann dieses Formular zu verwenden ist.',
  'set.tb.descPlaceholder': 'Beschreiben Sie, wann dieses Formular verwendet werden soll…',
  'set.tb.importedFields': 'Importierte Felder',
  'set.tb.importedHelp': 'Ziehen Sie Felder, um sie neu anzuordnen. Mit dem Schalter nehmen Sie ein Feld in dieses Formular auf oder schließen es aus.',
  'set.tb.noneInSection': 'Keine importierten Felder in diesem Abschnitt.',
  'set.tb.dragReorder': 'Zum Neuanordnen ziehen',
  'set.tb.required': 'Erforderlich',
  'set.tb.nested': 'Verschachtelt',
  'set.tb.enableField': '{label} aktivieren',
  'set.tb.enabled': 'Aktiviert',
  'set.tb.disabled': 'Deaktiviert',
  'set.tb.emptyTitle': 'Noch keine Felder zu konfigurieren',
  'set.tb.emptyDesc': 'Importieren Sie Ticketfelder, um mit dem Erstellen dieses Formulars zu beginnen.',
  'set.tb.deleting': 'Wird gelöscht…',
  'set.tp.loadError': 'Die Formularvorschau konnte nicht geladen werden.',
  'set.tp.preview': 'Vorschau',
  'set.tp.customerPreview': 'Kundenansicht (Vorschau)',
  'set.tp.backToBuilder': 'Zurück zum Builder',
  'set.tp.modeTitle': 'Vorschaumodus',
  'set.tp.modeDesc': 'Dies ist eine Vorschau ohne Absenden. Alle aktivierten Felder werden in der gespeicherten Formularreihenfolge angezeigt.',
  'set.tp.emptyTitle': 'Noch keine Felder aktiviert',
  'set.tp.emptyDesc': 'Aktivieren Sie Felder im Formular-Builder, um sie in dieser Vorschau zu sehen.',

  'por.error.generic': 'Die Anfrage konnte nicht abgeschlossen werden.',
  'por.error.requestNotFound': 'Anfrage nicht gefunden.',
  'por.error.formUnavailable': 'Das Anfrageformular ist nicht verfügbar.',
  'por.error.articleNotFound': 'Artikel nicht gefunden.',
  'por.error.selectRating': 'Bitte wählen Sie eine Bewertung von 1 bis 5.',
  'por.tab.all': 'Alle',
  'por.list.title': 'Meine Support-Anfragen',
  'por.list.description': 'Verfolgen Sie Ihre Anfragen und antworten Sie dem Support-Team.',
  'por.list.newRequest': 'Neue Anfrage',
  'por.list.knowledgeBase': 'Wissensdatenbank',
  'por.list.filterByStatus': 'Anfragen nach Status filtern',
  'por.list.searchPlaceholder': 'Nach Betreff suchen…',
  'por.list.count': '{count} Anfragen',
  'por.list.countOne': '{count} Anfrage',
  'por.list.emptyFilteredTitle': 'Keine Anfragen entsprechen dieser Ansicht',
  'por.list.emptyTitle': 'Noch keine Anfragen',
  'por.list.emptyFilteredDescription': 'Versuchen Sie den Tab „Alle“ oder einen anderen Suchbegriff.',
  'por.list.emptyDescription': 'Reichen Sie eine Anfrage ein, und das Support-Team nimmt sich ihrer an.',
  'por.list.submitFirst': 'Ihre erste Anfrage einreichen',
  'por.col.request': 'Anfrage',
  'por.col.subject': 'Betreff',
  'por.col.status': 'Status',
  'por.col.priority': 'Priorität',
  'por.col.created': 'Erstellt',
  'por.detail.myRequests': 'Meine Anfragen',
  'por.detail.reopen': 'Diese Anfrage wieder öffnen',
  'por.detail.attachments': 'Anhänge',
  'por.detail.download': 'Herunterladen',
  'por.detail.conversation': 'Konversation',
  'por.detail.noReplies': 'Noch keine Antworten',
  'por.detail.noRepliesHint': 'Fügen Sie unten eine Antwort hinzu, und das Support-Team nimmt sich ihrer an.',
  'por.detail.reply': 'Antworten',
  'por.detail.replyPlaceholder': 'Antwort schreiben',
  'por.detail.sending': 'Wird gesendet…',
  'por.detail.sendReply': 'Antwort senden',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': '{name} entfernen',
  'por.submit.newRequest': 'Neue Anfrage',
  'por.submit.defaultTitle': 'Support-Anfrage einreichen',
  'por.submit.intro': 'Füllen Sie die folgenden Felder aus und reichen Sie Ihre Anfrage ein.',
  'por.submit.subjectRequired': 'Der Betreff ist erforderlich',
  'por.submit.descriptionRequired': 'Die Beschreibung ist erforderlich',
  'por.submit.attachments': 'Anhänge',
  'por.submit.submitting': 'Wird eingereicht…',
  'por.submit.submit': 'Anfrage einreichen',
  'por.kb.portal': 'Portal',
  'por.kb.title': 'Wissensdatenbank',
  'por.kb.description': 'Finden Sie Antworten, bevor Sie eine Anfrage einreichen.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Suchergebnisse',
  'por.kb.searchPlaceholder': 'Artikel suchen',
  'por.kb.emptyTitle': 'Noch keine Artikel veröffentlicht',
  'por.kb.emptyDescription': 'Reichen Sie eine Anfrage ein, und das Support-Team hilft Ihnen direkt.',
  'por.kb.noFolders': 'Keine Ordner',
  'por.kb.articles': '{count} Artikel',
  'por.kb.articlesOne': '{count} Artikel',
  'por.kb.noMatch': 'Keine Artikel entsprechen „{query}“',
  'por.kb.folderEmpty': 'Noch keine Artikel in diesem Ordner',
  'por.kb.noMatchHint': 'Versuchen Sie einen kürzeren Suchbegriff oder reichen Sie stattdessen eine Anfrage ein.',
  'por.kb.folderEmptyHint': 'Durchsuchen Sie einen anderen Ordner oder reichen Sie stattdessen eine Anfrage ein.',
  'por.kb.submitRequest': 'Anfrage einreichen',
  'por.kb.views': '{count} Aufrufe',
  'por.kb.thanks': 'Danke für Ihr Feedback!',
  'por.kb.helpful': 'War dies hilfreich?',
  'por.kb.yes': 'Ja',
  'por.kb.no': 'Nein',
  'por.csat.thanksTitle': 'Vielen Dank für Ihr Feedback',
  'por.csat.thanksBody': 'Ihre Antwort wurde erfasst.',
  'por.csat.title': 'Wie haben wir abgeschnitten?',
  'por.csat.request': 'Anfrage #{number}: {subject}',
  'por.csat.rating': 'Bewertung',
  'por.csat.stars': '{count} Sterne',
  'por.csat.comment': 'Kommentar',
  'por.csat.submit': 'Feedback senden',
  'agents.tempPassword.title': 'Temporäres Passwort',
  'agents.tempPassword.help': 'Legen Sie ein temporäres Passwort für diesen Agenten fest. Bei der nächsten Anmeldung muss er ein neues Passwort wählen. Mindestens 12 Zeichen.',
  'agents.tempPassword.button': 'Temporäres Passwort festlegen',
  'agents.tempPassword.saving': 'Wird festgelegt…',
  'agents.tempPassword.error': 'Das temporäre Passwort konnte nicht festgelegt werden.',
  'ui.showPassword': 'Passwort anzeigen',
  'ui.hidePassword': 'Passwort verbergen',
  'dashboard.awaitingResolutionConfirmation': 'Wartet auf Lösungsbestätigung',
  'dashboard.awaitingUserReply': 'Wartet auf Benutzerantwort',
  'dashboard.changeRequests': 'Änderungsanforderungen',
  'agents.tempPassword.successEmailed': 'Temporäres Passwort festgelegt und per E-Mail an den Agenten gesendet.',
  'agents.tempPassword.successNotEmailed': 'Temporäres Passwort festgelegt, aber die E-Mail konnte nicht gesendet werden. Teilen Sie das Passwort dem Agenten über einen sicheren Kanal mit.',
} as const;

export default de;
